<template>
  <div id="Newproductbox" style="width: 100%;">
    <Breadcrumbs :title="$t('lbl_EMPBE_CompanyInfoCenter')" v-if="!this.supplierId" />
    <visitorPermission>
      <template v-slot:body>
        <!-- Container-fluid starts-->
        <div class="container-fluid">         
          <div class="tbbody">  
      <b-form :class="[fromAdmin ? 'formAdmin' : 'form', { 'Newproductbox--has-draft-banner': showDraftBanner && !fromAdmin }]" :style="formDynamicStyle" class="theme-form datepicker-responsive" id="productInfoForm"> 
        <!--管理员界面头部--> 
      <div class="TabHeader_admin customStickyCardHeader"  v-if="fromAdmin" ref="stickyHeader">
        <div v-if="showDraftBanner" class="product-draft-banner product-draft-banner--above-body">
          <svg class="product-draft-banner__icon" width="19" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4 11H12V9H4V11ZM4 14H12V12H4V14ZM4 17H9V15H4V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" fill="#5D5125"/>
          </svg>
          <div class="product-draft-banner__content">
            <div class="product-draft-banner__title">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Title') }}</div>
            <div class="product-draft-banner__desc">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Desc') }}</div>
          </div>
        </div>
        <div class="TabHeader_body">
          
          <div class="headerTitleBlock">
            <div class="headerBreadcrumbLine">
            <div class="lblproductList"  @click="backToDefaultPage">{{ $t('Lbl_AllProducts')}} 
                <!-- <span class="split" ></span> -->
              </div>
              <i class="fa fa-angle-right iconRight" aria-hidden="true" ></i>
              <div class="productTitleRow">
                <div class="productTitle" :title="GetPageTitleName()">{{ GetPageTitleName() }}</div>
                <span v-if="showAdminProductId" class="productIdBadge">#{{ ThenProductId }}</span>
              </div>
          </div> 
            <div class="statusLine">
              <span class="statusLabel">{{ $t('lbl_EMPBE_ProductsStatus') }}</span>
              <span
                v-show="statusLoaded"
                class="statusPill"
                :class="launchStatusClass"
                v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Product_LaunchStatus_Tooltip'))"
              ><i class="product-launch-badge__dot"></i>{{ launchStatusLabel }}</span>
              <span class="statusLabel">{{ $t('lbl_EMPBE_ReviewStatus') }}</span>
              <span
                v-show="statusLoaded"
                class="statusPill"
                :class="reviewStatusClass"
                v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Product_ReviewStatus_Tooltip'))"
              >{{ reviewStatusLabel }}</span>
                  </div>
                  </div>
              
          <div class="topMenuRight">
            <div class="topActionGroup">
                <span
                  class="headerActionBtn-wrap"
                  v-b-tooltip.hover.bottom="viewLiveTooltipConfig()"
                >
                  <button
                    type="button"
                    class="headerActionBtn"
                    :disabled="!canViewLive"
                    @click="todoViewLive"
                  >
                    <span class="headerActionBtn__label">{{ $t('lbl_EMPBE_ViewPublishedVersion') }}</span>
                    <img class="headerActionBtn__icon" :src="iconOpenInNew" alt="" />
                  </button>
                </span>
              <PubCustomSelect flat :from-admin="fromAdmin" :LiList="GetLiList" @ResultClick="DeleteAndDelisted">
              <template v-slot:HeadTitle>
                  <div class="headerMoreAction">{{ $t('lbl_EMPBE_MoreAction') }}</div>
              </template>
            </PubCustomSelect>
            </div>
          </div>
                </div>

          
      </div>
      <!--end--> 
    <div class="TabHeader" v-else ref="stickyHeader">
        <div v-if="showDraftBanner" class="product-draft-banner product-draft-banner--above-body">
          <svg class="product-draft-banner__icon" width="19" height="24" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M4 11H12V9H4V11ZM4 14H12V12H4V14ZM4 17H9V15H4V17ZM2 20C1.45 20 0.979167 19.8042 0.5875 19.4125C0.195833 19.0208 0 18.55 0 18V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H10L16 6V18C16 18.55 15.8042 19.0208 15.4125 19.4125C15.0208 19.8042 14.55 20 14 20H2ZM9 7V2H2V18H14V7H9Z" fill="#5D5125"/>
          </svg>
          <div class="product-draft-banner__content">
            <div class="product-draft-banner__title">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Title') }}</div>
            <div class="product-draft-banner__desc">{{ $t('lbl_EMPBE_AdDetail_DraftNewer_Desc') }}</div>
          </div>
        </div>
        <div class="TabHeader_body">

          <div class="headerTitleBlock">
            <div class="headerBreadcrumbLine">
            <!--  <div style="" class="backToDefaultPage"> 
                  <div style="width: 25.60px; height: 25.60px; position: relative; overflow: hidden">
                    <img src="https://cdn.adsalecdn.com/EMP/Backend/svg/ProductInfo/arrowLeft.svg">
                  </div> 
              </div>-->
              <div class="lblproductList"  @click="backToDefaultPage">{{ $t('Lbl_AllProducts')}} 
                <!-- <span class="split" ></span> -->
              </div>
              <i class="fa fa-angle-right iconRight" aria-hidden="true" ></i>
              <div class="productTitle" :title="GetPageTitleName()">{{ GetPageTitleName() }}</div>
          </div> 
            <div class="statusLine">
              <span class="statusLabel">{{ $t('lbl_EMPBE_ProductsStatus') }}</span>
              <span
                v-show="statusLoaded"
                class="statusPill"
                :class="launchStatusClass"
                v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Product_LaunchStatus_Tooltip'))"
              ><i class="product-launch-badge__dot"></i>{{ launchStatusLabel }}</span>
              <span class="statusLabel">{{ $t('lbl_EMPBE_ReviewStatus') }}</span>
              <span
                v-show="statusLoaded"
                class="statusPill"
                :class="reviewStatusClass"
                v-b-tooltip.hover.bottom="viewportTooltip($t('lbl_EMPBE_Product_ReviewStatus_Tooltip'))"
              >{{ reviewStatusLabel }}</span>
                </div>
          </div> 
          
            <div class="topMenuRight">
              <div class="topActionGroup">
                <span
                  class="headerActionBtn-wrap"
                  v-b-tooltip.hover.bottom="viewLiveTooltipConfig()"
                >
                  <button
                    type="button"
                    class="headerActionBtn"
                    :disabled="!canViewLive"
                    @click="todoViewLive"
                  >
                    <span class="headerActionBtn__label">{{ $t('lbl_EMPBE_ViewPublishedVersion') }}</span>
                    <img class="headerActionBtn__icon" :src="iconOpenInNew" alt="" />
                  </button>
                </span>
                <PubCustomSelect flat :from-admin="fromAdmin" :LiList="GetLiList" @ResultClick="DeleteAndDelisted">
              <template v-slot:HeadTitle>
                    <div class="headerMoreAction">{{ $t('lbl_EMPBE_MoreAction') }}</div>
              </template>
            </PubCustomSelect>
                </div>
                </div>
                </div>
          <!-- 供应商：已驳回横幅放入 fixed 标题栏内，避免被挡住并把左右栏顶歪 -->
          <div   v-if="showSupplierRejectBanner"
            class="product-reject-banner" >
            <div class="product-reject-banner__title">
              {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Title') }}
          </div>
            <!-- 第二行固定默认说明；有总驳回原因时再追加一行 -->
            <div class="product-reject-banner__desc-group">
              <p class="product-reject-banner__desc">
                {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Desc') }}
              </p>
              <p
                v-if="rejectBannerHeaderReason"
                class="product-reject-banner__desc"
              >
                {{ rejectBannerHeaderReason }}
              </p>
            </div>
            <button
              v-if="rejectedApprovalCount > 0"
              type="button"
              class="product-reject-banner__link"
              @click="showRejectDetailsModal = true"
            >
              {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_ViewDetails', { totalNo: rejectedApprovalCount }) }}
              <i class="fa fa-angle-right product-reject-banner__link-icon" aria-hidden="true"></i>
            </button>
            </div>
          </div>
      <!-- 管理员编辑模式：已驳回横幅 不需要固定 -->
          <div  v-if="showAdminEditRejectBanner"
            class="product-reject-banner"
          >
            <div class="product-reject-banner__title">
              {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Title') }}
      </div>
            <div class="product-reject-banner__desc-group">
              <p class="product-reject-banner__desc">
              {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_Desc') }}
            </p>
            <p
              v-if="rejectBannerHeaderReason"
              class="product-reject-banner__desc"
            >
              {{ rejectBannerHeaderReason }}
            </p>
            </div>
            <button
              v-if="rejectedApprovalCount > 0"
              type="button"
              class="product-reject-banner__link"
              @click="showRejectDetailsModal = true"
            >
              {{ $t('lbl_EMPBE_ProductInfo_RejectBanner_ViewDetails', { totalNo: rejectedApprovalCount }) }}
              <i class="fa fa-angle-right product-reject-banner__link-icon" aria-hidden="true"></i>
            </button>
          </div>
      <!-- 总驳回：不放进吸顶标题栏，滚动时随页面走 -->
      <ProductOverallRejectPanel
        ref="overallRejectPanel"
        v-if="statusLoaded && isApprovalMode && showProductRejectPanels"
        v-model="overallRejectReasonDraft"
        :actor="approvalRejectBy"
        :templates="overallRejectTemplates"
        :force-active="hasSelectedFieldReject"
        :rejected-count="selectedFieldRejectCount"
      />

      <ProductRejectDetailsModal
        v-model="showRejectDetailsModal"
        :results="approvalContentResults"
        :rejected-time="approvalRejectedTime"
        :is-approval-mode="isApprovalMode"
      />

      <PublicTabs 
          v-model="TabIndex" 
          :TabList="TabList" 
          :TabStyle="2" 
          :Loading="false" 
          :IsHiddenRight="true"
          :IsSavePrompt="!isApprovalMode" 
          :AutoSaveOnTabChange="true"
          :AlwaysAutoSaveOnTabChange="isApprovalMode && showProductRejectPanels"
          :PageLeaveType="PageLeaveType"
          :RightOnleftFooterShow="false"
          :ProgressValue="Number((progressModel && (progressModel.progress != null ? progressModel.progress : progressModel.Progress)) || 0)"
          @submit="Submit"
          @save="onTabSave" 
          @input="selectTab"
          >
                  <!-------定义左侧left menu 头部内容------->
              <template v-slot:TabCardHead>
              <div>
                <span class="bCardTitle">{{ $t('lbl_EMPBE_ProductInfo_Title') }}</span>
                <p class="bCardTitle_P">{{ $t('lbl_EMPBE_ProductInfo_Memu_Title_Tips') }}
                </p>
              </div>
            </template>
              <!-------进度条 和 未填写项列表------->
            <template v-slot:TabCardFoot>
              <LeftMenuFooter  :dataList="unFillFiledList"  :progressModel="progressModel" :selectedTabName="selectedTabName" @selected="selectName" ></LeftMenuFooter>
            </template> 

            <!--提交时间 / 审批时间--> 
            <template v-slot:RightSlot>
              <proInfoUpdateTime
                :submitDate="lastSubmitDate"
                :approvalDate="displayApprovalActionTime"
                :permissionData="permissionData"
              />
            </template>
                  <!-------传入相关的 tab 页 组件------->

                  <template v-slot:tab0>
              <!-- 用 div 而非 fieldset：Chrome 下 fieldset+pointer-events:none 会吞掉子级 textarea 点击 -->
              <div
                class="product-submit-fieldset"
                :class="{ 'is-approval-readonly': isApprovalMode }"
              >
              <BasicInfo
                :supplierId="companyid"
                ref="tab0"
                :ProductId="ThenProductId"
                :SelectOptions="SelectOptions"
                :permissionData="permissionData"
                :PageLeaveType="PageLeaveType"
                :submitType="submitType"  @uploadFinish="UploadFinish"
                />
              </div>
              <div style="" class="backAndNext"  v-show="!IsSaveOrSubmitBtnClicked && !isApprovalMode">
              
                <div  class="backBtn" style="visibility: hidden;">
                        
                    </div>
                <div class="rightBtn" @click="preOrNextTab('PricingTradeInfo')" >
                        <span>{{$t('lbl_emp3_next1')}}</span>
                        <span class="el-icon-right" style="font-weight: bold;"></span>
                </div>
              </div>
            </template>
                  
                  <template v-slot:tab1>
              <div
                class="product-submit-fieldset"
                :class="{ 'is-approval-readonly': isApprovalMode }"
              >
              <PricingTradeInfo
                :supplierId="companyid"
                ref="tab1"
                :ProductId="ThenProductId"
                :SelectOptions="SelectOptions"
                :permissionData="permissionData"
                :PageLeaveType="PageLeaveType"
                :submitType="submitType"
              />
              </div>

              <div style="" class="backAndNext"    v-show="!IsSaveOrSubmitBtnClicked && !isApprovalMode">
                <div  class="backBtn"  @click="preOrNextTab('BasicInfo')">
                        <span class="el-icon-back" style="font-weight: bold;"></span>
                        <span >{{$t('Lbl_Back')}}</span>
                    </div>
                <div class="rightBtn" @click="preOrNextTab('ProductDetail')">
                        <span>{{$t('lbl_emp3_next1')}}</span>
                        <span class="el-icon-right" style="font-weight: bold;"></span>
                </div>
            </div>

            </template>
            <template v-slot:tab2>
              <div
                class="product-submit-fieldset"
                :class="{ 'is-approval-readonly': isApprovalMode }"
              >
              <ProductDetails
                :supplierId="companyid"
                ref="tab2"
                :ProductId="ThenProductId"
                :SelectOptions="SelectOptions"
                :permissionData="permissionData"
                :PageLeaveType="PageLeaveType"
                :submitType="submitType"
                @submit="Submit"
                @save="Save"
                @uploadFinish="UploadFinish"
              />
              </div>
              <div style="" class="backAndNext"  v-show="!IsSaveOrSubmitBtnClicked && !isApprovalMode">
                <div  class="backBtn"  @click="preOrNextTab('PricingTradeInfo')">
                        <span class="el-icon-back" style="font-weight: bold;"></span>
                        <span >{{$t('Lbl_Back')}}</span>
                    </div>
                <div class="rightBtn" @click="preOrNextTab('ProductTags')">
                        <span>{{$t('lbl_emp3_next1')}}</span>
                        <span class="el-icon-right" style="font-weight: bold;"></span>
                </div>
              </div>
            </template>
            <template v-slot:tab3>
              <div
                class="product-submit-fieldset"
                :class="{ 'is-approval-readonly': isApprovalMode }"
              >
              <ProductTags
                :supplierId="companyid"
                ref="tab3"
                :ProductId="ThenProductId"
                :SelectOptions="SelectOptions"
                :permissionData="permissionData"
                :PageLeaveType="PageLeaveType"
                :submitType="submitType"
                :IsMainProductExceeds="GetMainProductCount <= mainProductCount"
                :mainProductIds="mainProductIds"
              />
              </div>
              <div style="" class="backAndNext"  v-show="!IsSaveOrSubmitBtnClicked && !isApprovalMode">
                <div  class="backBtn"  @click="preOrNextTab('ProductDetail')">
                        <span class="el-icon-back" style="font-weight: bold;"></span>
                        <span >{{$t('Lbl_Back')}}</span>
                    </div>
                <div class="rightBtn" style="visibility: hidden;">
                        <span>{{$t('lbl_emp3_next1')}}</span>
                        <span class="el-icon-right" style="font-weight: bold;"></span>
                </div>
              </div>
            </template>
                </PublicTabs>

        <div class="customizer-formbutton" v-if="$route.params.id&&!fromAdmin && !isApprovalMode">
  
                  <b-button-group>
                    <!-- <button type="button" class="btn btn-light btn-lg" @click="GotoWebSite"
                      v-bind:t_label="'EMPBE_CompanyInfoCenter_GotoWebSite'">
                      <i class="fa fa-eye m-r-5"></i>{{$t("lbl_EMPBE_Preview")}}
                    </button> -->
                <button :disabled="IsSaveOrSubmitBtnClicked" type="button" class="btn btn-primary btn-lg" @click="btnSave_Click"
                v-if="showSaveButton" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSave'">
                <i class="fa far fa-save m-r-5"></i>
                <!-- <span v-if="TabList.length - 1 == TabIndex">
                  {{ $t("lbl_EMPBE_CompanyInfo_Save") }}
                </span>
                <span v-else> -->
                  {{ $t("lbl_EMPBE_CompanyInfo_SaveDraft") }}
                <!-- </span> -->
              </button>

                  <button v-if="isUAT" type="button" class="btn btn-warning btn-lg" @click="btnSyncToFrontEnd_Click"
                v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSyncToFrontEnd'">
                <i class="fa fa-refresh m-r-5"></i>{{ $t("Lbl_SyncToFrontEnd") }} (Debug)
              </button>
                  <button :disabled="IsSaveOrSubmitBtnClicked" type="button" class="btn btn-success btn-lg" @click="btnSubmit_Click"
                v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSubmit'">
                <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_CompanyInfo_Submit") }}
              </button>
                    <!-- <button type="button" class="btn btn-success btn-lg" @click="saveCompanyInfoAndNext"
                      v-if="TabIndex < (TabList.length-1)" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSaveAndNext'"
                      >
                      <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_SaveAndNext") }}
                    </button> -->
                  </b-button-group>
                </div>
        <!--- 管理员-->
        <div  class="customizer-formbutton"  v-if="fromAdmin && !isApprovalMode">
          <b-button-group> 
            <button :disabled="IsSaveOrSubmitBtnClicked" type="button" class="btn btn-outline-info btn-lg" @click="btnSave_Click"
                v-if="showSaveButton" v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSave'"> 
        
              {{ $t("lbl_EMPBE_Save2") }} 
          </button>
                <button v-else :disabled="IsSaveOrSubmitBtnClicked" type="button" class="btn btn-outline-info btn-lg" @click="btnSubmit_Click"
            v-bind:t_label="'EMPBE_CompanyInfoCenter_btnSubmit'">
            <i class="fa fa-send m-r-5"></i>{{ $t("lbl_EMPBE_CompanyInfo_Submit") }}
          </button> 
          </b-button-group>
        </div>
        </b-form>
        </div>
        </div>
        <!-- Container-fluid Ends-->

      </template>
    </visitorPermission>
  </div>
</template>
 <script>
import { productService, resolveProductRowStatus, isProductDraftStatus, resolveProductLaunchStatus, hasProductListDraftIndicator, PRODUCT_DISPLAY_STATUS, PRODUCT_LAUNCH_STATUS, PRODUCT_REVIEW_STATUS_I18N, unwrapProductListPayload, canShowProductSaveButton } from "@/_services/product.service";
import {
  isProductApprovalRejectedRow,
  isProductApprovalResultRadioSelected,
  resolveProductApprovalResultCodeForSave,
  resolveProductRejectReasonText,
  PRODUCT_APPROVAL_RESULT_CODE_SELECTED,
  PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED,
} from "./productApprovalFieldMeta";
import { CompanyInfoService } from "@/_services/CompanyInfo.Service";
import { LogService } from "@/_services/log.Service";
import LeftMenuFooter from "./Popup/LeftMeunFooter.vue"
import proInfoUpdateTime  from "./Popup/ProInfoUpdateTime.vue"
import BasicInfo from "./Popup/BasicInfo.vue"
import PricingTradeInfo from "./Popup/PricingTradeInfo.vue"
import ProductDetails from "./Popup/ProductDetails.vue"
import ProductTags from "./Popup/ProductTags.vue"
import ProductRejectDetailsModal from "./ProductRejectDetailsModal.vue"
import ProductOverallRejectPanel from "./ProductOverallRejectPanel.vue"
import { adminService } from "@/_services/admin.service";
import { AlertDialog } from "@/_helpers/AlertDialog"; 
import { viewportTooltip } from "@/_helpers/tooltip";
import { resolveApprovalRejectByActor } from "@/_helpers/approvalActor";
import { buildApprovalConfirmDialogBody } from '@/_helpers/approvalConfirmDialog';
import { mapState } from "vuex";
import { SHOW_EDIT_SUPPLIER_REJECT_REASON, isVisibleApprovalRejectRow, shouldIncludeRejectHintsInTodo, tabHasSubmitBlockingUnfilled } from '@/constants/approvalRejectUi.js';

const defaultUploadResult = {
  isSuccessful: true,
  message: "",
  failedItems: [],
};

export default {
  components: {
    LeftMenuFooter,
    proInfoUpdateTime,
    BasicInfo,
    PricingTradeInfo,
    ProductDetails,
    ProductTags,
    ProductRejectDetailsModal,
    ProductOverallRejectPanel,
  },
  props: {
    supplierId: { default: null },
    ProductId: { default: null },
    fromAdmin: { type: Boolean, default: false },
    /** edit=可编辑；approval=审批只读，隐藏字段驳回红框 */
    submitType: { type: String, default: 'edit' },
  },
  inject: {
    permissionData: { default: null },
    ChildSubmit: { default: null },
  },
  provide() {
    return {
      productApprovalHost: this,
    };
  },
  mixins: [AlertDialog],
  data() {
    return { 
      IsSaveOrSubmitBtnClicked: false,
      goingToTabIndex:-1,
      isShowSubmitBox:false,
      TabIndex: 0,  
      ProductQuota: 0,
      ProductCount: 0,
      ProductCurrentOccupiesQuota: false,
      TabList: [
        { name: this.$t('lbl_EMPBE_ProductInfo_Memu_BasicInfo'), status: 0, t_label: "EMPBE_CompanyInfoCentera", IsShow: true, ProgressPage: "BasicInfo" },
        { name: this.$t('lbl_EMPBE_ProductInfo_Memu_PricingTradeInfo'), status: 0, t_label: "EMPBE_CompanyInfoCenterb", IsShow: true, ProgressPage: "PricingTradeInfo" },
        { name: this.$t('lbl_EMPBE_ProductInfo_Memu_ProductDetails'), status: 0, t_label: "EMPBE_CompanyInfoCenterc", IsShow: true, ProgressPage: "ProductDetail" },
        { name: this.$t('lbl_EMPBE_ProductInfo_Memu_ProductTags'), status: 0, t_label: "EMPBE_CompanyInfoCenterd", IsShow: true, ProgressPage: "ProductTags" },
      ],
      ProductName: "",
      lastSaveDate: "",
      lastSubmitDate: "",
      IsLaunch: 0,
      approvalStatusCode: null,
      /** 打开审批页时记录的 ApprovalId，Finish 时与后端最新值比对 */
      loadedApprovalId: null,
      approvalRejectReason: "",
      approvalRejectBy: "",
      /** 页头总驳回草稿，对应审批表 RejectReason（非字段级） */
      overallRejectReasonDraft: "",
      overallRejectTemplates: [],
      /** Cache key for overallRejectTemplates: approvalId, or 0 when loaded via GetRejectReasons fallback */
      overallRejectTemplatesApprovalId: null,
      approvalContentResults: [],
      approvalContentResultDrafts: {},
      /** 上次落库的子项 ResultCode（勾选会改 live 行，需单独基线做 dirty 判断） */
      approvalContentResultCodeBaseline: {},
      /** Finish 校验：已勾选子项但原因为空时按 draftKey 存错误文案 */
      fieldRejectErrorByKey: {},
      approvalRejectedTime: null,
      /** 侧栏「审批时间」：最近一次审批/驳回时间 */
      approvalActionTime: null,
      showRejectDetailsModal: false,
      savingApprovalResultIds: {},
      statusLoaded: false,
      cdnURL: "https://cdn.adsalecdn.com/EMP/Backend/",
      iconOpenInNew: require('@/assets/images/icon-open-in-new.svg'),
      PRODUCT_DISPLAY_STATUS,
      PRODUCT_LAUNCH_STATUS,
      Progress: 0,
      IsMainProduct:false,
      unFillFiledList:null,
      progressModel:Object,
      LiList: [
        { name: this.$t('lbl_EMPBE_ProductInfo_Delist'), eventName: "Delist", status: 0 },
        { name: this.$t('lbl_EMPBE_Delete'), eventName: "Delete", status: 1 },
      ],
      SelectOptions:
      {
        IndustriesOptions: [],               //行业列表--公司选择的
        MstIndustriesOptions: [],               //行业列表--基础库
        ProductCategoriesOptions: [],        //产品分类列表
        MstCategoriesOptions: [],        //产品分类列表
        TagsOptions: [],                      //产品标签列表
        UOMOptions: [],                       //产能Unit列表
        AbilityunitOptions: [],               //产能Time列表
        NewsOptions: [],                      //新品范围列表
        countryOptions: [],                   //国家（国家/省/市）
        ProvOptions: [],                      //省（国家/省/市）
        cityOptions: [],                      //市（国家/省/市）
        ProductCertifiationTypeOptions: [],   //产品认证类型列表
        LeadTimeOptions: [],                  //發貨時間列表
        ProductCatalogOptions: []             //产品目录下拉列表
      },
      isDataLoaded:false,
      PageLeaveContent:
      {
        SubmitTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
        SubmitText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
        SubmitConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Submit'),
        SaveTitle: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
        SaveText: this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
        SaveConfirmBtn: this.$t('lbl_EMPBE_CompanyInfo_Save'),
      },
      mainProductCount: 0,
      mainProductIds:[],
      loading:false,
      keyIndex:0,
      selectedTabName:'BasicInfo', 

      uploadResult: { ...defaultUploadResult },
      stickyLayoutOffsets: {
        contentTop: 64,
        leftTop: 128,
        mainOffsetLeft: 0,
        headerOffsetLeft: 0,
        formWidth: 1167,
        formLeft: 0,
      },
      pageBodyResizeObserver: null,
    };
  },
  computed: {
    ...mapState("submitFormMessage", { isShowSubmitAlertMessage : "isShowModal" }),

    GetMainProductCount() {
      if (this.permissionData) {
        switch (this.permissionData["Type"]) {
          case "A+":
            return 10;
          case "A":
            return 5;
          case "B":
            return 2;
          case "Member":
            return 1;
        }
      }
      return 0;
    },
    PageLeaveType() {
      if (this.GetPageState == 1) {
        return 1;
      } else {
        return 2;
      }
    },
    /** approval 模式下整页只读 */
    isApprovalMode() { 
      return String(this.submitType || 'edit').toLowerCase() === 'approval';
    },
    displayApprovalStatus() {
      return resolveProductRowStatus({ statusCode: this.approvalStatusCode });
    },
    launchStatus() {
      return resolveProductLaunchStatus({
        statusCode: this.approvalStatusCode,
        isLaunch: this.IsLaunch,
      });
    },
    launchStatusLabel() {
      return this.launchStatus === PRODUCT_LAUNCH_STATUS.online
        ? this.$t('lbl_EMPBE_Product_Online')
        : this.$t('lbl_EMPBE_Product_Offline');
    },
    launchStatusClass() {
      return this.launchStatus === PRODUCT_LAUNCH_STATUS.online
        ? 'is-launch-online'
        : 'is-launch-offline';
    },
    reviewStatusLabel() {
      const key = PRODUCT_REVIEW_STATUS_I18N[this.displayApprovalStatus]
        || PRODUCT_REVIEW_STATUS_I18N.toBeSubmitted;
      return this.$t(key);
    },
    reviewStatusClass() {
      const code = (this.approvalStatusCode == null ? '' : String(this.approvalStatusCode)).trim().toUpperCase();
      if (code === 'D') return 'is-delisted';
      if (code === 'I') return 'is-invalid';
      if (code === 'ES') return 'is-effective-soon';
      if (code === 'UR') return 'is-under-review';
      const display = this.displayApprovalStatus;
      if (display === PRODUCT_DISPLAY_STATUS.live) return 'is-approved';
      if (display === PRODUCT_DISPLAY_STATUS.rejected) return 'is-rejected';
      if (display === PRODUCT_DISPLAY_STATUS.pending) return 'is-syncing';
      if (display === PRODUCT_DISPLAY_STATUS.pendingManualAudit) return 'is-manual';
      return 'is-not-submitted';
    },
    canViewLive() {
      return this.launchStatus === PRODUCT_LAUNCH_STATUS.online;
    },
    isApprovalPending() {
      return this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.pending
        || this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.pendingManualAudit;
    },
    isProductRejectedStatus() {
      return this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.rejected;
    },
    /** 供应商已驳回横幅：不进 fixed 标题栏（TEMP 开关关闭时不展示） */
    showSupplierRejectBanner() {
      return SHOW_EDIT_SUPPLIER_REJECT_REASON
        && !this.fromAdmin
        && this.statusLoaded
        && this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.rejected;
    },
    /** 管理员编辑模式已驳回横幅（TEMP 开关关闭时不展示） */
    showAdminEditRejectBanner() {
      return SHOW_EDIT_SUPPLIER_REJECT_REASON
        && this.fromAdmin
        && this.statusLoaded
        && !this.isApprovalMode
        && this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.rejected;
    },
    /** 已审批通过（A = live） */
    isProductApprovedLive() {
      return this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.live;
    },
    /**
     * 驳回相关 UI（页头总驳回 / 字段驳回框 / 媒体驳回）：
     * - 已驳回(R)：显示
     * - 审批模式 + 已上架(A)：显示（可查看/勾选驳回框）
     * - 审批中(P) / 人工待审批(PA) / 未提交：不显示
     */
    showProductRejectPanels() {
      const s = this.displayApprovalStatus;
      if (s === PRODUCT_DISPLAY_STATUS.rejected) return true;
      if (this.isApprovalMode && s === PRODUCT_DISPLAY_STATUS.live) return true;
      return false;
    },
    rejectedApprovalCount() {
      return (this.approvalContentResults || []).filter((row) =>
        isVisibleApprovalRejectRow(row, this),
      ).length;
    },
    /** 任一子项 radio 已选时，总驳回联动勾选 */
    hasSelectedFieldReject() {
      return (this.approvalContentResults || []).some((row) =>
        isProductApprovalRejectedRow(row)
      );
    },
    /** 总驳回角标：已勾选子项数量 */
    selectedFieldRejectCount() {
      return (this.approvalContentResults || []).filter((row) =>
        isProductApprovalRejectedRow(row)
      ).length;
    },
    canSubmitForApproval() {
      if (this.isApprovalPending) return false;
      if (this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.live) return false;
      return isProductDraftStatus(this.approvalStatusCode) || this.GetPageState !== 1;
    },
    showDraftBanner() {
      return hasProductListDraftIndicator({
        displayStatus: this.displayApprovalStatus,
        lastSaveDate: this.lastSaveDate,
        lastSubmitDate: this.lastSubmitDate,
      }) && !this.fromAdmin;
    },
    showSaveButton() {
      return canShowProductSaveButton(this.displayApprovalStatus);
    },
    /** 横幅追加行：表头总驳回原因（有则显示；第二行默认说明始终单独展示） */
    rejectBannerHeaderReason() {
      return String(this.approvalRejectReason || '').trim();
    },
    /** 侧栏审批时间展示值 */
    displayApprovalActionTime() {
      return this.approvalActionTime || this.approvalRejectedTime || '';
    },
      GetPageState() {
      if (this.isApprovalPending) return 2;
      if (this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.live
        || (this.lastSubmitDate && (this.IsLaunch == 1 || this.IsLaunch == true))) {
        return 1;
      }
      if (this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.rejected
        || !this.lastSubmitDate
        || (this.lastSaveDate && this.lastSubmitDate && this.lastSaveDate > this.lastSubmitDate)) {
        return 0;
      }
      return 2;
    },
    GetLiList() {
      // [More Action] 不同审核状态下的按钮（🔒=disabled）
      // 1 未提交: 切换模式🔒 / Delist🔒 / Delete
      // 2 待审批·待人工审批: 切换模式 / Delist🔒 / Delete🔒
      // 3 已驳回: 切换模式 / Delist(已下架则🔒) / Delete
      // 4 待生效 / 5 已审批: 切换模式 / Delist(已下架则🔒) / Delete
      // 注：切换模式仅管理员可见；已下架一律不可再点下架
      const isOnline = this.launchStatus === PRODUCT_LAUNCH_STATUS.online;
      const reviewStatus = this.displayApprovalStatus;
      const isPending = reviewStatus === PRODUCT_DISPLAY_STATUS.pending
        || reviewStatus === PRODUCT_DISPLAY_STATUS.pendingManualAudit;
      const isDraft = reviewStatus === PRODUCT_DISPLAY_STATUS.toBeSubmitted;

      const delistItem = {
        name: this.$t('lbl_EMPBE_ProductInfo_Delist'),
        eventName: 'Delist',
        status: 0,
        disabled: !isOnline || isDraft || isPending,
        iconClass: 'fa fa-eye-slash graybg',
      };
      const deleteItem = {
        name: this.$t('lbl_EMPBE_Delete'),
        eventName: 'Delete',
        status: 1,
        disabled: false,
        iconClass: 'fa fa-trash',
      };

      if (isPending) {
        // 2 待审批 / 待人工审批：删除也不可点
        deleteItem.disabled = true;
      }

      if (this.fromAdmin) {
        // 编辑模式（管理员后台）→ 文案「切换审批模式」；审批模式（公司资料审批后台）→「切换编辑模式」
        const switchModeItem = {
          name: this.isApprovalMode
            ? this.$t('lbl_EMPBE_SwitchToEditMode')
            : this.$t('lbl_EMPBE_SwitchEditApprovalMode'),
          eventName: 'SwitchMode',
          status: 0,
          disabled: !this.isApprovalMode && isDraft,
          iconClass: 'fa fa-external-link graybg',
        };
        return [switchModeItem, delistItem, deleteItem];
      }

      return [delistItem, deleteItem];
    },
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId === null ||
        this.supplierId === undefined ||
        this.supplierId === ""
        ? this.user.empCompanyId
        : this.supplierId;
    },
    langid() {
      return localStorage.getItem("currentLangId");
    },
    GetTabRef() {
      return "tab" + this.TabIndex;
    },
    ThenProductId() {
      return this.$route.params.id ? this.$route.params.id : this.ProductId;
    },
    showAdminProductId() {
      const id = Number(this.ThenProductId);
      return this.fromAdmin && Number.isFinite(id) && id > 0;
    },
    AplusABCBasicBooth() {
    if (this.permissionData) {
        return ["A+", "A", "B", "C", "Member"].includes(this.permissionData["Type"]);
      } else {
        return false;
      }
    },
    isUAT() {
      return process.env.VUE_APP_EMP_IsUat === 'true' || process.env.VUE_APP_EMP_IsUat === '1';
    },
    formDynamicStyle() {
      if (this.fromAdmin) {
        return {
          '--np-admin-left-top': `${this.stickyLayoutOffsets.leftTop}px`,
        };
      }
      return {
        '--np-content-top': `${this.stickyLayoutOffsets.contentTop}px`,
        '--np-left-top': `${this.stickyLayoutOffsets.leftTop}px`,
        '--np-main-offset-left': `${this.stickyLayoutOffsets.mainOffsetLeft}px`,
        '--np-header-offset-left': `${this.stickyLayoutOffsets.headerOffsetLeft}px`,
        '--np-form-width': `${this.stickyLayoutOffsets.formWidth}px`,
        '--np-form-left': `${this.stickyLayoutOffsets.formLeft}px`,
      };
    }
  },
  watch:
  {
    //在default.vue 页面 层级中需要做离开此页是否保存的操作 所以这里只能用监听以及跨层级来触发他的提交
    ChildSubmit: {
      handler() {
        if (this.ChildSubmit.state) {
          if (this.GetPageState == 1)
            this.Submit();
          else
            this.Save();
        }
      },
      deep: true
    },

    isShowSubmitAlertMessage: {
      handler(newValue, oldValue) {
        if (newValue === false && oldValue === true) {
          this.AfterHideMessageModal();
        }
      }
    },
    showDraftBanner() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    isProductRejectedStatus() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    showSupplierRejectBanner() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    showAdminEditRejectBanner() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
      });
    },
    rejectedApprovalCount() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
        this.refreshTabExclamationMarks();
      });
    },
    statusLoaded(val) {
      if (val) {
        this.$nextTick(() => {
          this.refreshStickyLayoutOffsets();
        });
      }
    },
    showProductRejectPanels() {
      this.$nextTick(() => {
        this.refreshStickyLayoutOffsets();
        this.refreshTabExclamationMarks();
      });
    },
    isProductApprovedLive() {
      this.$nextTick(() => {
        this.refreshTabExclamationMarks();
      });
    },
  },
  mounted() {
    
    this.InitData();
    this.GetMainProductCountAsync();
    this.$nextTick(() => {
      const headerEl = this.$refs.stickyHeader;
      if (headerEl) {
        headerEl.style.width = '';
        headerEl.style.left = '';
      }
      this.refreshStickyLayoutOffsets();
    });
    window.addEventListener('resize', this.refreshStickyLayoutOffsets);
    this.bindPageBodyResizeObserver();
  },
  created() {

  },
  methods: {
    viewportTooltip,
    viewLiveTooltipConfig() {
      return viewportTooltip(this.$t('lbl_EMPBE_ViewPublishedVersion_Tooltip'));
    },
    bindPageBodyResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return;
      const pageBody = document.querySelector('.page-body');
      const formEl = document.getElementById('productInfoForm');
      if (!pageBody && !formEl) return;
      this.pageBodyResizeObserver = new ResizeObserver(() => {
        this.refreshStickyLayoutOffsets();
      });
      if (pageBody) this.pageBodyResizeObserver.observe(pageBody);
      if (formEl) this.pageBodyResizeObserver.observe(formEl);
    },
    refreshStickyLayoutOffsets() {
      const headerEl = this.$refs.stickyHeader;
      const formEl = document.getElementById('productInfoForm');
      if (!headerEl || !headerEl.offsetHeight || !formEl) return;
      const formRect = formEl.getBoundingClientRect();
      const headerHeight = headerEl.offsetHeight;
      const pageBody = document.querySelector('.page-body');
      const mainOffsetLeft = pageBody ? pageBody.getBoundingClientRect().left : 0;
      const headerOffsetLeft = headerEl.getBoundingClientRect().left;
      if (this.fromAdmin) {
        // 管理员：左侧吸顶与 sticky 头底边对齐（勿再 +间隙，否则下滑时左右顶不齐）
        this.stickyLayoutOffsets = {
          contentTop: headerHeight,
          leftTop: Math.max(1, headerHeight),
          mainOffsetLeft,
          headerOffsetLeft,
          formWidth: formRect.width,
          formLeft: formRect.left,
        };
        return;
      }
      // Keep original spacing baseline, and auto-expand when banner increases header height.
      const contentTop = Math.max(64, headerHeight - 24);
      const leftTop = Math.max(128, headerHeight + 40);
      this.stickyLayoutOffsets = {
        contentTop,
        leftTop,
        mainOffsetLeft,
        headerOffsetLeft,
        formWidth: formRect.width,
        formLeft: formRect.left,
      };
    },
    UploadFinish(failedFilesFields) {
      const isSuccess = failedFilesFields.length === 0;

      this.uploadResult.isSuccessful = isSuccess;
      this.uploadResult.failedItems = [...this.uploadResult.failedItems, ...failedFilesFields];

      this.$submitFormMessage.FinishUploadPopup({ isSuccess });
    },

    ShowResultMessagePopup(isSuccess, message, isSubmit, missingFields = [], header = '') {
      const isSuccessful = isSuccess && this.uploadResult.isSuccessful;
      const uploadFailedItems = this.uploadResult.failedItems;

      this.$submitFormMessage.ShowResultPopup({
        isSuccess: isSuccessful,
        message,
        isSubmit,
        missingFields,
        uploadFailedItems,
        header,
      });
    },

    AfterHideMessageModal() {
      this.uploadResult = { ...defaultUploadResult };
    },

     GetPageTitleName() {
      return this.ThenProductId > 0 ? (this.ProductName ? this.ProductName : this.$t('Lbl_Products')) : this.$t('lbl_EMPBE_ProductInfo_ProductGrid_AddProduct')
    },
    refreshCompantedFunc(){
      this.keyIndex += 1;
    },
    InitData() {
      this.loading = true;
      this.statusLoaded = false;
      this.GetOptions();
      this.GetProductQuota();
      this.GetProductCount();
      // 先拉审批驳回，再算左侧未填；感叹号依赖两者
      Promise.resolve(this.LoadPagetTimer())
        .then(() => this.loadData())
        .catch(() => this.loadData());
    },
    GetMainProductCountAsync() {
      productService
        .GetMainProductCountAsync({ companyId: this.companyid })
        .then((res) => {
          if (res.isSuccessful) {
            this.mainProductCount = res.data.counts;
            this.mainProductIds = res.data.productIds.split(",");
          }
        }).catch(() => {
        })
    },
    //获取leftmemu 及 rightmenu 数据
    async loadData() {
      const includeRejectHints = shouldIncludeRejectHintsInTodo(this);
      const baseParams = {
        companyId: this.companyid,
        ProductId: this.ThenProductId,
        includeRejectHints: false,
      };

      try {
        const baseRes = await productService.GetProductInToFiledList(baseParams);
        if (!baseRes.isSuccessful) return;

        let displayList = baseRes.data;
        if (includeRejectHints) {
          const hintRes = await productService.GetProductInToFiledList({
            ...baseParams,
            includeRejectHints: true,
          });
          if (hintRes.isSuccessful) {
            displayList = hintRes.data;
          }
        }

        const newMpaList = [];
        this.TabList.forEach((item) => {
          const basePageList = baseRes.data['temp' + item.ProgressPage] || [];
          const pageList = displayList['temp' + item.ProgressPage] || [];
          // 提交校验只用「真正未填必填」，不含字段驳回提示
          item._hasUnfilledRequired = basePageList.some(
            (a) => Number(a.isRequired) === 1 || a.isRequired === true,
          );
          if (item.IsShow && pageList.length > 0) {
            newMpaList.push({ name: item.ProgressPage, lblName: item.name, todoList: pageList });
          }
        });
        this.progressModel = displayList.totalModel;
        this.unFillFiledList = newMpaList;
        this.refreshTabExclamationMarks();
      } catch (e) {
        console.error(e);
      }
    },
    /** 某 Tab 是否有字段驳回（与 ProductFieldApprovalResults / 媒体驳回框同一套可见规则） */
    tabHasRejectedFields(page) {
      const types = this.getRejectUsageTypesByPage(page) || [];
      if (!types.length) return false;
      return this.getProductApprovalResultsByUsageType(types).some((row) =>
        isVisibleApprovalRejectRow(row, this),
      );
    },
    /**
     * 左侧感叹号 = 未填必填 或 该 Tab 有字段驳回。
     * 审批模式：驳回只看 resultCode；编辑/供应商：还需非空驳回文案。
     * 待优化列表的驳回并入由 GetProductInToFiledList.includeRejectHints 控制，与此处 hasReject 一致。
     */
    refreshTabExclamationMarks() {
      if (!this.TabList || !this.TabList.length) return;
      const showRejectMark = shouldIncludeRejectHintsInTodo(this);
      this.TabList.forEach((item, idx) => {
        if (!item.ProgressPage) return;
        const hasUnfilled = !!item._hasUnfilledRequired;
        const hasReject = showRejectMark
          && this.tabHasRejectedFields(item.ProgressPage);
        this.$set(this.TabList[idx], '_hasRejectedFields', hasReject);
        this.$set(this.TabList[idx], 'status', (hasUnfilled || hasReject) ? 1 : 0);
      });
    },
    formatProductDateTime(date) {
      const d = date instanceof Date ? date : new Date(date);
      if (Number.isNaN(d.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    refreshDraftBannerTimestamps() {
      const next = this.formatProductDateTime(new Date());
      if (next) this.lastSaveDate = next;
    },
    async LoadPagetTimer() {
      this.statusLoaded = false;
      try {
      await productService
        .GetProductInfoStatus({
          companyId: this.companyid,
          ProductId: this.ThenProductId,
          useFormalTables: this.isApprovalMode,
        })
        .then((res) => {
          if (res.isSuccessful) {
            this.lastSaveDate = res.data?.lastSaveDate;
            this.lastSubmitDate = res.data?.lastSubmitDate;
            this.IsLaunch = res.data?.isLaunch;
            this.ProductName = this.langid == 936 ? res.data?.productNameSc : (this.langid == 950 ? res.data?.productNameTc : res.data?.productNameEn);
            this.IsMainProduct= res.data?.isMainProduct;

          }
        });
        await this.LoadApprovalStatus();
      } finally {
        this.statusLoaded = true;
      }
    },
    async LoadApprovalStatus() {
      if (!this.ThenProductId || !this.companyid) {
        this.approvalStatusCode = null;
        this.loadedApprovalId = null;
        this.approvalRejectReason = '';
        this.approvalRejectBy = '';
        this.overallRejectReasonDraft = '';
        this.overallRejectTemplates = [];
        this.overallRejectTemplatesApprovalId = null;
        this.approvalContentResults = [];
        this.approvalContentResultDrafts = {};
        this.approvalContentResultCodeBaseline = {};
        this.approvalRejectedTime = null;
        this.approvalActionTime = null;
        this.refreshTabExclamationMarks();
        return;
      }
      try {
        const statusRes = await productService.GetProductApprovalStatus({
          companyId: this.companyid,
          ProductId: this.ThenProductId,
        });
        if (statusRes?.isSuccessful && statusRes.data) {
          this.approvalStatusCode = statusRes.data.statusCode ?? statusRes.data.StatusCode ?? null;
          this.loadedApprovalId = this.pickApprovalId(statusRes.data);
          this.approvalRejectReason = resolveProductRejectReasonText(
            statusRes.data.rejectReason || statusRes.data.RejectReason || '',
          );
          this.approvalRejectBy = resolveApprovalRejectByActor(statusRes.data);
          this.overallRejectReasonDraft = this.approvalRejectReason;
          this.approvalActionTime = this.resolveApprovalActionTimeFromStatus(statusRes.data);
        } else {
          this.approvalStatusCode = null;
          this.loadedApprovalId = null;
          this.approvalRejectReason = '';
          this.approvalRejectBy = '';
          this.overallRejectReasonDraft = '';
          this.approvalActionTime = null;
        }
          //回传给审批父页面，
          if(this.fromAdmin){ 
           this.$emit('open-detail','product',this.approvalStatusCode);
          }

        const shouldLoadDetail = this.fromAdmin
          || this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.rejected
          || this.isApprovalPending
          || (this.isApprovalMode && this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.live);

        if (shouldLoadDetail) {
          const detailRes = await productService.GetProductApprovalDetail({
            empCompanyId: this.companyid,
            productId: this.ThenProductId,
          });
          if (detailRes?.isSuccessful && detailRes.data) {
            this.setApprovalContentResults(detailRes.data.approvalContentResults || []);
            this.approvalRejectedTime = this.resolveApprovalRejectedTime(detailRes.data);
            if (!this.approvalActionTime) {
              this.approvalActionTime = this.resolveApprovalActionTimeFromDetail(detailRes.data)
                || this.approvalRejectedTime;
            }
            if (!this.approvalStatusCode && detailRes.data.approvalHeader) {
              this.approvalStatusCode = detailRes.data.approvalHeader.statusCode;
            }
            const headerId = this.pickApprovalId(detailRes.data.approvalHeader);
            if (headerId) this.loadedApprovalId = headerId;
            // 历史记录里最新一条带 RejectReason 的可补全总驳回（与审批页总体驳回说明同源）
            if (!this.overallRejectReasonDraft) {
              const fromHistory = this.resolveOverallRejectFromHistory(detailRes.data);
              if (fromHistory.reason) {
                const reason = resolveProductRejectReasonText(fromHistory.reason);
                this.approvalRejectReason = reason;
                this.overallRejectReasonDraft = reason;
              }
              if (!this.approvalRejectBy && fromHistory.by) {
                this.approvalRejectBy = fromHistory.by;
              }
            }
          } else {
            this.setApprovalContentResults([]);
            this.approvalRejectedTime = null;
            if (!this.approvalActionTime) this.approvalActionTime = null;
          }
        } else {
          this.setApprovalContentResults([]);
          this.approvalRejectedTime = null;
        }

        // After status + optional detail so loadedApprovalId is final (cache keyed by id)
        if (this.isApprovalMode) {
          await this.loadOverallRejectTemplates();
        }
      } catch (e) {
        this.approvalStatusCode = null;
        this.loadedApprovalId = null;
        this.approvalRejectReason = '';
        this.approvalRejectBy = '';
        this.overallRejectReasonDraft = '';
        this.overallRejectTemplates = [];
        this.overallRejectTemplatesApprovalId = null;
        this.setApprovalContentResults([]);
        this.approvalRejectedTime = null;
        this.approvalActionTime = null;
      }
    },
    /** 从状态/详情响应取出 ApprovalId */
    pickApprovalId(payload) {
      if (!payload || typeof payload !== 'object') return null;
      const id = Number(payload.approvalId ?? payload.ApprovalId ?? 0);
      return id > 0 ? id : null;
    },
    /**
     * Finish 前比对打开页时 ApprovalId 与后端最新 ApprovalId
     * @returns {Promise<boolean>} true=可继续审批
     */
    async ensureApprovalNotStale() {
      if (!this.fromAdmin || !this.isApprovalMode) return true;
      const openedId = Number(this.loadedApprovalId) || 0;
      if (openedId <= 0 || !this.ThenProductId || !this.companyid) return true;
      try {
        const statusRes = await productService.GetProductApprovalStatus({
          companyId: this.companyid,
          ProductId: this.ThenProductId,
        });
        const latestId = this.pickApprovalId(statusRes?.data) || 0;
        if (latestId > 0 && latestId !== openedId) {
          await this.showApprovalStaleReloadDialog();
          return false;
        }
      } catch (e) {
        // 拉取失败不阻断审批，避免网络抖动误拦
      }
      return true;
    },
    async showApprovalStaleReloadDialog() {
      const res = await this.$swal({
        text: this.$t('lbl_EMPBE_ApprovalStale_Body'),
        showCancelButton: false,
        confirmButtonText: this.$t('lbl_EMPBE_Reload'),
        confirmButtonColor: '#7366FF',
        allowOutsideClick: false,
      });
      if (!res.isConfirmed) return;
      try {
        if (typeof this.loadData === 'function') {
          await this.loadData();
        }
        await this.LoadApprovalStatus();
      } catch (e) {
        // reload best-effort
      }
    },
    /** 状态接口：取最近审批/驳回时间 */
    resolveApprovalActionTimeFromStatus(status) {
      if (!status) return null;
      return status.rejectDate
        || status.RejectDate
        || status.approvalDate
        || status.ApprovalDate
        || status.approvalUpdatedDate
        || status.ApprovalUpdatedDate
        || null;
    },
    /** 详情历史：取最近一条 A/R 的审批时间 */
    resolveApprovalActionTimeFromDetail(detail) {
      const history = detail?.approvalHistory || [];
      for (let i = history.length - 1; i >= 0; i -= 1) {
        const row = history[i];
        const code = String(row?.statusCode ?? row?.StatusCode ?? '').trim().toUpperCase();
        if (code !== 'A' && code !== 'R') continue;
        return row?.rejectDate
          ?? row?.RejectDate
          ?? row?.approvalDate
          ?? row?.ApprovalDate
          ?? row?.createdDate
          ?? row?.CreatedDate
          ?? null;
      }
      const header = detail?.approvalHeader;
      return header?.updatedDate ?? header?.UpdatedDate ?? null;
    },
    /** 从审批历史补全总驳回原因（ApprovalDetail.RejectReason） */
    resolveOverallRejectFromHistory(detail) {
      const history = detail?.approvalHistory || [];
      for (let i = history.length - 1; i >= 0; i -= 1) {
        const row = history[i];
        const code = String(row?.statusCode ?? row?.StatusCode ?? '').trim().toUpperCase();
        const reason = row?.rejectReason ?? row?.RejectReason ?? '';
        if (code === 'R' || reason) {
          return {
            reason: reason || '',
            by: resolveApprovalRejectByActor(row),
          };
        }
      }
      return { reason: '', by: '' };
    },
    /** 供后续 Finish/驳回提交读取：页头总驳回草稿 */
    getOverallRejectReason() {
      return (this.overallRejectReasonDraft || '').trim();
    },
    /** 总驳回 radio 是否勾选（决定完成时走驳回还是通过） */
    isOverallRejectActive() {
      const panel = this.$refs.overallRejectPanel;
      if (panel && typeof panel.isRejectActive === 'function') {
        return panel.isRejectActive();
      }
      return false;
    },
    /**
     * 审批模式「完成」：
     * - 总驳回 radio 已勾选 → 确认驳回弹窗 → ProductApprove R
     * - 总驳回 radio 未勾选 → 确认通过弹窗 → ProductApprove A
     * @returns {{ ok: boolean, statusCode?: 'R'|'A' }}
     */
    async finishProductApproval() {
      if (!this.fromAdmin || !this.isApprovalMode) return { ok: false };
      if (!this.ThenProductId) return { ok: false };

      // 供应商重新提交会产生新 ApprovalId：打开页记录的与最新不一致则阻止审批
      if (!(await this.ensureApprovalNotStale())) {
        return { ok: false };
      }

      // Finish 前落库全部 Tab 子项，避免只保存当前页导致其它页草稿丢失
      await this.saveApprovalRejectContent({ silent: true, scope: 'all' });

      const isReject = this.isOverallRejectActive();
      let blocked = false;
      let fieldsMissing = false;

      // 已勾选子项必须填写驳回原因（框内提示 + 滚到首项）
      if (!(await this.validateSelectedFieldRejectReasons())) {
        blocked = true;
        fieldsMissing = true;
      }

      if (isReject) {
        const overall = this.getOverallRejectReason();
        if (!overall) {
          const panel = this.$refs.overallRejectPanel;
          const msg = this.$t('lbl_EMPBE_ProductInfo_OverallReject_Placeholder');
          if (panel && typeof panel.showReasonError === 'function') {
            // 若同时有字段缺原因，优先滚到字段；总驳回只标红不抢滚动
            panel.showReasonError(msg, { scroll: !fieldsMissing });
          } else if (!fieldsMissing && panel && typeof panel.focusReason === 'function') {
            panel.focusReason();
          }
          blocked = true;
        }
        if (blocked) return { ok: false };
        const ok = await this.confirmAndSubmitProductApproval('R', overall);
        return { ok: !!ok, statusCode: 'R' };
      }

      if (blocked) return { ok: false };
      const ok = await this.confirmAndSubmitProductApproval('A', '');
      return { ok: !!ok, statusCode: 'A' };
    },
    /** 已勾选且原因为空的子项 */
    getMissingFieldRejectReasons() {
      return (this.approvalContentResults || []).filter((result) => {
        if (!isProductApprovalResultRadioSelected(result.resultCode)) return false;
        const reason = String(this.getProductApprovalResultDraft(result) || '').trim();
        return !reason;
      });
    },
    getPageForRejectUsageType(usageType) {
      const usage = String(usageType || '').trim();
      if (!usage) return '';
      const pages = ['BasicInfo', 'PricingTradeInfo', 'ProductDetail', 'ProductTags'];
      for (let i = 0; i < pages.length; i += 1) {
        const page = pages[i];
        if (this.getRejectUsageTypesByPage(page).includes(usage)) return page;
      }
      return '';
    },
    getFieldRejectErrorMessage(result) {
      const key = this.getProductApprovalResultDraftKey(result);
      if (!key) return '';
      return this.fieldRejectErrorByKey[key] || '';
    },
    clearFieldRejectError(result) {
      const key = this.getProductApprovalResultDraftKey(result);
      if (!key || !this.fieldRejectErrorByKey[key]) return;
      this.$delete(this.fieldRejectErrorByKey, key);
    },
    clearAllFieldRejectErrors() {
      this.fieldRejectErrorByKey = {};
    },
    /**
     * 校验已勾选子项驳回原因；失败时写入框内错误、切 Tab，并滚到首个缺项（同必填项体验）
     * @returns {Promise<boolean>}
     */
    async validateSelectedFieldRejectReasons() {
      const missing = this.getMissingFieldRejectReasons();
      if (!missing.length) {
        this.clearAllFieldRejectErrors();
        return true;
      }
      const msg = this.$t('lbl_EMPBE_ProductInfo_OverallReject_Placeholder');
      const errors = {};
      missing.forEach((row) => {
        const key = this.getProductApprovalResultDraftKey(row);
        if (key) errors[key] = msg;
      });
      this.fieldRejectErrorByKey = errors;

      const firstKey = this.getProductApprovalResultDraftKey(missing[0]);
      const firstPage = this.getPageForRejectUsageType(missing[0].usageType);
      if (firstPage) {
        const idx = (this.TabList || []).findIndex((t) => t.ProgressPage === firstPage);
        if (idx >= 0 && idx !== this.TabIndex) {
          this.TabIndex = idx;
          this.selectTab(idx);
        }
      }
      await this.scrollToFieldRejectError(firstKey);
      return false;
    },
    /** 滚到指定驳回框并聚焦输入（对齐 PageValidate 必填项） */
    async scrollToFieldRejectError(resultKey) {
      const key = String(resultKey || '').trim();
      if (!key) return;
      await this.$nextTick();
      await new Promise((resolve) => setTimeout(resolve, 150));
      const root = this.$el;
      if (!root || typeof root.querySelector !== 'function') return;
      const safeKey = key.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      const el = root.querySelector(`[data-approval-result-key="${safeKey}"]`);
      if (!el) return;
      if (typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      }
      const input = el.querySelector('textarea.frf__input, .frf__input');
      if (input && typeof input.focus === 'function') {
        setTimeout(() => input.focus(), 180);
      }
    },
    /** 各产品 Tab 对应的字段 UsageType（与各 Popup 内 ProductFieldApprovalResults 一致） */
    getRejectUsageTypesByPage(page) {
      const map = {
        BasicInfo: [
          'ExhibitNameE',
          'ExhibitNameS',
          'ExhibitOtherNameE',
          'ExhibitOtherNameS',
          'ExhibitPhoto',
          'ExhibitVideo',
          'ExhibitVideo_Cover',
          'ExhibitVideo_Short',
          'ExhibitVideo_Short_Cover',
          'ModelNum',
          'Ability_Number',
        ],
        PricingTradeInfo: ['MOQ_Unit_Other', 'ProductPriceDisplay'],
        ProductDetail: [
          'DescE',
          'DescS',
          'DescT',
          'CertificationType',
          'CertificationName',
          'eBooth_Exhibit_Certificate',
          'ExhibitCertification',
        ],
        ProductTags: [],
      };
      return map[page] || [];
    },
    /** 当前产品 Tab 对应的字段 UsageType */
    getCurrentTabRejectUsageTypes() {
      const page = this.TabList?.[this.TabIndex]?.ProgressPage || '';
      return this.getRejectUsageTypesByPage(page);
    },
    /**
     * 组装待保存的子项驳回列表
     * @param {'current'|'all'} scope current=仅当前页；all=全部 Tab
     */
    buildFieldRejectsForSave(scope = 'current') {
      const rows = this.approvalContentResults || [];
      const allowTypes = scope === 'all'
        ? null
        : this.getCurrentTabRejectUsageTypes();
      const allowSet = allowTypes ? new Set(allowTypes.map((x) => String(x).trim())) : null;

      return rows
        .map((result) => {
          const id = Number(result.approvalRequestResultId) || 0;
          if (id <= 0) return null;
          const usage = String(result.usageType || '').trim();
          if (allowSet && !allowSet.has(usage)) return null;
          // 勾选 → ResultCode=2；未勾选 → ResultCode=1（未勾选不带原因）
          const selected = isProductApprovalResultRadioSelected(result.resultCode);
          const resultCode = resolveProductApprovalResultCodeForSave(result.resultCode);
          return {
            approvalRequestResultId: id,
            rejectedReason: selected ? (this.getProductApprovalResultDraft(result) || '') : '',
            resultCode,
          };
        })
        .filter(Boolean);
    },
    /**
     * 驳回内容相对上次落库是否有改动（总驳回文案 / 子项勾选 / 子项原因）
     * 与供应商 dirty 一致：无改动则切 Tab 不调保存、不提示
     */
    hasApprovalRejectChanges(scope = 'current') {
      const overallNow = this.getOverallRejectReason();
      const overallSaved = String(this.approvalRejectReason || '').trim();
      if (overallNow !== overallSaved) return true;

      const fieldRejects = this.buildFieldRejectsForSave(scope);
      for (let i = 0; i < fieldRejects.length; i += 1) {
        const item = fieldRejects[i];
        const row = (this.approvalContentResults || []).find(
          (x) => Number(x.approvalRequestResultId) === Number(item.approvalRequestResultId),
        );
        if (!row) continue;
        const key = this.getProductApprovalResultDraftKey(row);
        const baselineCode = resolveProductApprovalResultCodeForSave(
          this.approvalContentResultCodeBaseline[key],
        );
        const nowCode = resolveProductApprovalResultCodeForSave(item.resultCode);
        if (baselineCode !== nowCode) return true;

        const wasSelected = isProductApprovalResultRadioSelected(baselineCode);
        const savedReason = wasSelected ? String(row.rejectReason || '').trim() : '';
        const nowReason = String(item.rejectedReason || '').trim();
        if (savedReason !== nowReason) return true;
      }
      return false;
    },
    syncApprovalResultCodeBaselineFromRows(rows) {
      const baseline = {};
      (rows || []).forEach((row) => {
        const key = this.getProductApprovalResultDraftKey(row);
        if (!key) return;
        baseline[key] = resolveProductApprovalResultCodeForSave(row.resultCode);
      });
      this.approvalContentResultCodeBaseline = baseline;
    },
    /**
     * 审批模式「保存」：表头总驳回 + 当前页（或全部）子项驳回
     * options.scope: 'current' | 'all'，默认 current
     */
    async saveApprovalRejectContent(options = {}) {
      const silent = !!options.silent;
      const scope = options.scope === 'all' ? 'all' : 'current';
      if (!this.fromAdmin || !this.isApprovalMode) return false;
      if (!this.ThenProductId) return false;

      const fieldRejects = this.buildFieldRejectsForSave(scope);

      try {
        const res = await productService.UpdateProductOverallRejectReason({
          productId: Number(this.ThenProductId) || 0,
          rejectReason: this.getOverallRejectReason(),
          fieldRejects,
        });
        if (!res?.isSuccessful) {
          if (!silent) {
            this.$message({
              message: this.$t('lbl_EMPBE_ProductInfo_ApprovalSavePartialFail'),
              type: 'warning',
            });
          }
          return false;
        }

        this.approvalRejectReason = this.overallRejectReasonDraft || '';
        fieldRejects.forEach((item) => {
          const idx = this.approvalContentResults.findIndex(
            (x) => Number(x.approvalRequestResultId) === Number(item.approvalRequestResultId)
          );
          if (idx >= 0) {
            const code = String(item.resultCode || PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED).trim()
              || PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED;
            this.$set(this.approvalContentResults, idx, {
              ...this.approvalContentResults[idx],
              rejectReason: item.rejectedReason || '',
              resultCode: code === PRODUCT_APPROVAL_RESULT_CODE_SELECTED
                || code === '0'
                ? PRODUCT_APPROVAL_RESULT_CODE_SELECTED
                : PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED,
            });
            this.setProductApprovalResultDraft(this.approvalContentResults[idx], item.rejectedReason || '');
            const key = this.getProductApprovalResultDraftKey(this.approvalContentResults[idx]);
            if (key) {
              this.$set(
                this.approvalContentResultCodeBaseline,
                key,
                resolveProductApprovalResultCodeForSave(item.resultCode),
              );
            }
          }
        });

        if (!silent) {
          this.$showEmpSuccessToast(this.$t('lbl_EMPBE_ProductInfo_ApprovalSaveSuccess'));
        }
        return true;
      } catch (e) {
        if (!silent) {
          this.$message({
            message: this.$t('lbl_EMPBE_ProductInfo_ApprovalSavePartialFail'),
            type: 'warning',
          });
        }
        return false;
      }
    },
    confirmAndSubmitProductApproval(statusCode, rejectReason) {
      const isReject = String(statusCode).toUpperCase() === 'R';
      return this.$swal({
        title: this.$t(
          isReject
            ? 'lbl_EMPBE_ProductInfo_ConfirmRejectTitle'
            : 'lbl_EMPBE_ProductInfo_ConfirmApproveTitle'
        ),
        html: buildApprovalConfirmDialogBody(this, {
          isReject,
          currentStatusCode: this.approvalStatusCode,
        }),
        showCancelButton: true,
        confirmButtonText: this.$t(
          isReject
            ? 'lbl_EMPBE_ProductInfo_ConfirmRejectOk'
            : 'lbl_EMPBE_ProductInfo_ConfirmApproveOk'
        ),
        cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
        // 与公司资料审批设计一致：左文案、右下 Cancel + 主按钮
        customClass: isReject ? 'AlertDialog-DEL' : 'AlertDialog-SaveSucess AlertDialog-Approve',
        reverseButtons: true,
        confirmButtonColor: isReject ? '#DC3545' : '#51BB25',
      }).then(async (res) => {
        if (!res.isConfirmed) return false;
        // 确认弹窗期间供应商可能再次提交，提交前再比对一次
        if (!(await this.ensureApprovalNotStale())) {
          return false;
        }
        try {
          const apiRes = await productService.ProductApprove({
            productIds: String(this.ThenProductId),
            statusCode: isReject ? 'R' : 'A',
            rejectReason: rejectReason || '',
            remark: '',
          });
          if (apiRes?.isSuccessful) {
            this.$showEmpSuccessToast(this.$t(
              isReject
                ? 'lbl_EMPBE_ProductInfo_RejectSuccess'
                : 'lbl_EMPBE_ProductInfo_ApproveSuccess'
            ));
            await this.LoadApprovalStatus();
            this.$emit('approval-finished', {
              statusCode: isReject ? 'R' : 'A',
              productId: this.ThenProductId,
            });
            return true;
          }
          this.$message({
            message: (apiRes?.systemErrorMsg && apiRes.systemErrorMsg.join('<br>'))
              || this.$t('lbl_EMPBE_ProductInfo_ApprovalActionFail'),
            type: 'error',
            dangerouslyUseHTMLString: true,
          });
          return false;
        } catch (e) {
          this.$message({
            message: this.$t('lbl_EMPBE_ProductInfo_ApprovalActionFail'),
            type: 'error',
          });
          return false;
        }
      });
    },
    async loadOverallRejectTemplates() {
      const approvalId = Number(this.loadedApprovalId) || 0;
      const cacheKey = approvalId > 0 ? approvalId : 0;
      if (
        this.overallRejectTemplates.length
        && this.overallRejectTemplatesApprovalId === cacheKey
      ) {
        return;
      }
      try {
        if (approvalId > 0) {
          const res = await adminService.GetRejectTemplatesByApprovalId(approvalId);
          if (res?.isSuccessful && res.data) {
            const raw = Array.isArray(res.data) ? res.data : [];
            const mapped = this.mapApprovalRejectTemplatesToFrf(raw);
            if (mapped.length) {
              this.overallRejectTemplates = mapped;
              this.overallRejectTemplatesApprovalId = cacheKey;
              return;
            }
          }
        }
        // No approvalId / empty / error → fall back to global reject reasons ({ id, label })
        this.overallRejectTemplates = await this.loadRejectReasonsAsFrfTemplates();
        this.overallRejectTemplatesApprovalId = cacheKey;
      } catch (e) {
        // 模板可选，失败时仅隐藏 Template 下拉
        console.error('loadOverallRejectTemplates', e);
      }
    },
    mapApprovalRejectTemplatesToFrf(raw) {
      return (Array.isArray(raw) ? raw : [])
        .map((item, idx) => {
          if (!item || typeof item !== 'object') return null;
          const title = String(item.Title ?? item.title ?? '').trim();
          const content = String(item.Content ?? item.content ?? '').trim();
          if (!title || !content) return null;
          const orderId = Number(item.OrderId ?? item.orderId);
          const hasOrder = Number.isFinite(orderId);
          return {
            id: hasOrder ? orderId : `tpl_${idx}`,
            title,
            content,
            _order: hasOrder ? orderId : idx,
          };
        })
        .filter(Boolean)
        .sort((a, b) => a._order - b._order)
        .map(({ id, title, content }) => ({ id, title, content }));
    },
    async loadRejectReasonsAsFrfTemplates() {
      const res = await adminService.GetRejectReasons();
      if (!res?.isSuccessful || !res.data) return [];
      const raw = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.reasons)
          ? res.data.reasons
          : Array.isArray(res.data.rejectReasons)
            ? res.data.rejectReasons
            : [];
      // FieldRejectionFeedback legacy shape: { id, label }
      return raw
        .map((item, idx) => {
          if (typeof item === 'string') {
            const label = String(item).trim();
            return label ? { id: `ovr_${idx}`, label } : null;
          }
          if (!item || typeof item !== 'object') return null;
          const label = item.RejectReason || item.rejectReason
            || item.RejectTitle || item.rejectTitle
            || item.reason || item.Reason || '';
          if (!String(label).trim()) return null;
          return { id: `ovr_${idx}`, label: String(label).trim() };
        })
        .filter(Boolean);
    },
    resolveApprovalRejectedTime(detail) {
      const history = detail?.approvalHistory || [];
      for (let i = history.length - 1; i >= 0; i -= 1) {
        const row = history[i];
        const rejectDate = row?.rejectDate ?? row?.RejectDate;
        if (rejectDate) return rejectDate;
        const code = String(row?.statusCode ?? row?.StatusCode ?? '').trim().toUpperCase();
        if (code === 'R') {
          return row?.approvalDate ?? row?.ApprovalDate ?? row?.createdDate ?? row?.CreatedDate ?? null;
        }
      }
      const header = detail?.approvalHeader;
      if (header?.updatedDate || header?.UpdatedDate) return header.updatedDate ?? header.UpdatedDate;
      const rejectedRows = (detail?.approvalContentResults || [])
        .map((row) => this.normalizeApprovalContentResult(row))
        .filter(isProductApprovalRejectedRow);
      let latest = null;
      rejectedRows.forEach((row) => {
        if (!row.auditDate) return;
        const ms = Date.parse(row.auditDate);
        if (Number.isNaN(ms)) return;
        if (latest == null || ms > latest) latest = ms;
      });
      return latest != null ? new Date(latest) : null;
    },
    normalizeApprovalContentResult(row) {
      if (!row) return null;
      const rejectReason = row.rejectedReason
        || row.RejectedReason
        || row.aiRejectedReason
        || row.AiRejectedReason
        || '';
      return {
        approvalRequestResultId: row.approvalRequestResultId ?? row.ApprovalRequestResultId ?? null,
        approvalRequestContentId: row.approvalRequestContentId ?? row.ApprovalRequestContentId ?? null,
        usageType: row.usageType ?? row.UsageType ?? '',
        usageId: row.usageId ?? row.UsageId ?? null,
        contentType: row.contentType ?? row.ContentType ?? '',
        content: row.content ?? row.Content ?? '',
        resultCode: row.resultCode ?? row.ResultCode ?? '',
        rejectReason,
        auditDate: row.auditDate ?? row.AuditDate ?? null,
        tabSection: row.tabSection ?? row.TabSection ?? '',
        fieldName: row.fieldName ?? row.FieldName ?? '',
        sortOrder: row.sortOrder ?? row.SortOrder ?? null,
      };
    },
    setApprovalContentResults(rows) {
      const list = (rows || [])
        .map((row) => this.normalizeApprovalContentResult(row))
        .filter(Boolean)
        .sort((a, b) => {
          const sa = a.sortOrder == null ? 9999 : Number(a.sortOrder);
          const sb = b.sortOrder == null ? 9999 : Number(b.sortOrder);
          if (sa !== sb) return sa - sb;
          return 0;
        });
      this.approvalContentResults = list;
      const drafts = {};
      list.forEach((row) => {
        const key = this.getProductApprovalResultDraftKey(row);
        if (key) drafts[key] = row.rejectReason || '';
      });
      this.approvalContentResultDrafts = drafts;
      this.syncApprovalResultCodeBaselineFromRows(list);
      this.refreshTabExclamationMarks();
    },
    getProductApprovalResultDraftKey(result) {
      if (!result) return '';
      const id = result.approvalRequestResultId;
      if (id != null && id !== '') return String(id);
      const usageId = result.usageId;
      if (usageId != null && usageId !== '') return `usage_id_${usageId}`;
      return `usage_${result.usageType || ''}`;
    },
    getProductApprovalResultsByUsageType(usageTypes) {
      const keys = (usageTypes || []).map((x) => String(x || '').trim()).filter(Boolean);
      if (!keys.length) return [];
      return (this.approvalContentResults || []).filter((row) => keys.includes(String(row.usageType || '').trim()));
    },
    getProductApprovalResultDraft(result) {
      const key = this.getProductApprovalResultDraftKey(result);
      if (!key) return '';
      if (Object.prototype.hasOwnProperty.call(this.approvalContentResultDrafts, key)) {
        return this.approvalContentResultDrafts[key];
      }
      return result?.rejectReason || '';
    },
    setProductApprovalResultDraft(result, value) {
      const key = this.getProductApprovalResultDraftKey(result);
      if (!key) return;
      this.$set(this.approvalContentResultDrafts, key, value == null ? '' : String(value));
      if (String(value || '').trim()) {
        this.clearFieldRejectError(result);
      }
    },
    setProductApprovalResultCode(result, value) {
      if (!result) return;
      // 勾选统一落 2，未勾选统一落 1
      const raw = value == null ? '' : String(value).trim();
      const selected = isProductApprovalResultRadioSelected(raw)
        || raw === PRODUCT_APPROVAL_RESULT_CODE_SELECTED;
      const code = selected
        ? PRODUCT_APPROVAL_RESULT_CODE_SELECTED
        : PRODUCT_APPROVAL_RESULT_CODE_UNSELECTED;
      const key = this.getProductApprovalResultDraftKey(result);
      const idx = (this.approvalContentResults || []).findIndex(
        (x) => this.getProductApprovalResultDraftKey(x) === key
      );
      if (idx >= 0) {
        this.$set(this.approvalContentResults, idx, {
          ...this.approvalContentResults[idx],
          resultCode: code,
        });
      } else {
        this.$set(result, 'resultCode', code);
      }
      if (!selected) {
        this.clearFieldRejectError(result);
      }
      // 子项勾选时联动勾上总驳回（可被用户再手动取消）
      if (selected) {
        const panel = this.$refs.overallRejectPanel;
        if (panel && typeof panel.ensureActive === 'function') {
          panel.ensureActive();
        }
      }
      // 与公司一致：勾选后立刻刷新左侧感叹号
      this.refreshTabExclamationMarks();
    },
    canSaveProductApprovalResult(result) {
      if (!this.fromAdmin || this.isApprovalMode) return false;
      const key = this.getProductApprovalResultDraftKey(result);
      if (!key || !result?.approvalRequestResultId) return false;
      const draft = this.getProductApprovalResultDraft(result);
      return draft !== (result.rejectReason || '');
    },
    isSavingProductApprovalResult(result) {
      const key = this.getProductApprovalResultDraftKey(result);
      return !!(key && this.savingApprovalResultIds[key]);
    },
    async saveProductApprovalResult(result) {
      if (!this.canSaveProductApprovalResult(result)) return;
      const key = this.getProductApprovalResultDraftKey(result);
      const draft = this.getProductApprovalResultDraft(result);
      this.$set(this.savingApprovalResultIds, key, true);
      try {
        const res = await productService.UpdateProductRejectReason({
          productId: Number(this.ThenProductId) || 0,
          approvalRequestResultId: Number(result.approvalRequestResultId) || 0,
          rejectedReason: draft,
        });
        if (res?.isSuccessful) {
          result.rejectReason = draft;
          const idx = this.approvalContentResults.findIndex(
            (x) => this.getProductApprovalResultDraftKey(x) === key
          );
          if (idx >= 0) {
            this.$set(this.approvalContentResults, idx, {
              ...this.approvalContentResults[idx],
              rejectReason: draft,
            });
          }
        }
      } finally {
        this.$set(this.savingApprovalResultIds, key, false);
      }
    },
    async GetProductQuota() {
      try {
        const res = await productService.getSysAccountPaymentInfo({ CompanyId: this.companyid, demodate: '' });
          if (res.isSuccessful) {
          this.ProductQuota = res.data?.find(a => a.rid == 1)?.totalQty ?? 0;
        }
      } catch (e) {
        console.error(e);
      }
      return this.ProductQuota;
    },
    async GetProductCount() {
      // 独立接口：占用数见 proc_GetProductApprovalQuotaUsage（下线+已审批不占）；并返回当前产品是否已占名额
      try {
        const res = await productService.GetProductApprovalQuotaUsage({
          companyId: this.companyid,
          productId: Number(this.ThenProductId) || 0,
        });
        if (res.isSuccessful && res.data) {
          this.ProductCount = res.data.usedCount ?? res.data.UsedCount ?? 0;
          this.ProductCurrentOccupiesQuota = !!(res.data.currentOccupies ?? res.data.CurrentOccupies);
        }
      } catch (e) {
        console.error(e);
      }
      return this.ProductCount;
    },
    showProductQuotaFullDialog() {
      const localeStr = this.langid === 936 ? 'simp' : this.langid === 950 ? 'trad' : this.langid === 1252 ? 'eng' : 'simp';
      const salesUrl = `https://www.chinaplasonline.com/eMarketplace/Supplier/${localeStr}`;
      return this.$swal({
        title: this.$t('lbl_EMPBE_ProductQuotaFull_Title'),
        html: this.$t('lbl_EMPBE_ProductQuotaFull_Body'),
        showCancelButton: true,
        cancelButtonText: this.$t('lbl_EMPBE_ProductQuotaFull_ContactSales'),
        confirmButtonText: this.$t('lbl_EMPBE_ProductQuotaFull_Ok'),
        customClass: 'AlertDialog-SaveSucess',
        reverseButtons: true,
        confirmButtonColor: '#7366FF',
      }).then((res) => {
        if (!res.isConfirmed && res.dismiss === 'cancel') {
          window.open(salesUrl, '_blank');
        }
      });
    },
    //获取子项需要的选项列表 防止每一个子页面重复调用
    async GetOptions() {
      //获取公司部分的应用行业
      productService.GetIndustryByCompanyId({ LangId: this.langid, CompanyId: this.companyid }).then((response) => {
        if (response.isSuccessful) {
          this.SelectOptions.IndustriesOptions = response.data;
        }
      });

      //应用行业基础库
        CompanyInfoService.GetIndustryList().then((response) => {
          if (response.isSuccessful) {
            var dataList = response.data; 
            this.SelectOptions.MstIndustriesOptions = dataList;
          }
        });
      //产品类别
      productService.GetProductCatByCompanyId({ LangId: this.langid, CompanyId: this.companyid }).then((response) => {
        if (response.isSuccessful) {
          this.SelectOptions.ProductCategoriesOptions = response.data;
        }
      });

      //产品品类--基础库
        // CompanyInfoService.GetProductCatList().then((response) => {

        //   //加行业
        //   if (response.isSuccessful) {
        //     var dataList = response.data;
        //     //删除空对象

        //     var y = dataList;
        //     var keyCount = Object.keys(y).length;
        //     for (var i = 0; i < keyCount; i++) {
        //       var questionCount = dataList[i]["children"].length;
        //       if (questionCount == 0) {
        //         delete dataList[i]["children"]; //删除主目录没有 子项的arrary属性，例如：其他项
        //       }
        //       for (let j = 0; j < questionCount; j++) {
        //         var emptyquestion = dataList[i]["children"][j]["children"].length;
        //         if (emptyquestion === 0) {
        //           delete dataList[i]["children"][j].children;
        //         }
        //         var questionobj = null;
        //         var questionCount2 = 0;
        //         if (dataList[i]["children"][j].hasOwnProperty("children")) {
        //           questionobj = dataList[i]["children"][j]["children"];
        //           if (questionobj != null) {
        //             questionCount2 = dataList[i]["children"][j]["children"].length;
        //           }
        //         }

        //         for (let k = 0; k < questionCount2; k++) {
        //           var emptyquestion =
        //             dataList[i]["children"][j]["children"][k]["children"].length;
        //           if (emptyquestion == 0) {
        //             //delete (dataList[i]['children'][j]['children'][k]);
        //             delete dataList[i]["children"][j]["children"][k].children;
        //           }
        //         }
        //       }
        //     }
        //   //console.log('MstCategoriesOptions:'+dataList);
        //     this.SelectOptions.MstCategoriesOptions = dataList;
            
        //   }
        // });
         CompanyInfoService.GetAllProductCategories().then((response) => {

          //加行业
          if (response.isSuccessful) {
            if(response.data){
            var dataList = response.data; 
            //console.log('GetAllProductCategories'+dataList.length);
            this.SelectOptions.MstCategoriesOptions = dataList;
             this.isDataLoaded=true;
            }
          }
        });

      //加载热搜标签
      productService.GetMstTag({ LangId: this.langid }).then((res) => {
        if (res.isSuccessful) {
          if(res.data&&res.data.length>0){
          this.SelectOptions.TagsOptions = res.data.map(item => {
            return {
              id: item.tagId,
              label: item.text
            }
          });
         }
        }
      });
      //产品目录下拉列表
      productService.GetCatalogueBuyDownloads({ CompanyId: this.companyid }).then((res) => {
        if (res.isSuccessful) {
          this.SelectOptions.ProductCatalogOptions = res.data.filter(item => item.langId == this.langid).map(item => {
            return {
              id: item.catalogId,
              label: item.name != '' ? item.name : this.$t('lbl_Newcatalog')
            }
          });
        }
      });
      //(国家/省/市)
      productService.GetCountryProvCityArea({ langId: this.langid }).then(res => {
        if (res.isSuccessful) {
          //国家
          {
            if(res.data&&res.data.country&&res.data.country.length>0){
              this.SelectOptions.countryOptions = res.data.country.filter(a => a.countryID != 240)
                .map(item => {
                  return {
                    id: item.countryID,
                    label: item.countryName
                  }
                })
                
              ////将 125 / 96 / 206 置顶  默认 44 最大
              if (this.SelectOptions.countryOptions.length > 0) {
                this.countryOptionsUpdateOrder(125);
                this.countryOptionsUpdateOrder(96);
                this.countryOptionsUpdateOrder(206);
                this.countryOptionsUpdateOrder(44);
              }
           }
          }
          //省
          {
            if(res.data&&res.data.resProv&&res.data.resProv.length>0){
              this.SelectOptions.ProvOptions = res.data.resProv.map(item => {
              return {
                id: item.provCode,
                label: item.provName
              }
            });
           }
          }
          //市
          {
            if(res.data&&res.data.city&&res.data.city.length>0){
            this.SelectOptions.cityOptions = res.data.city.map(item => {
              return {
                id: item.city_id,
                label: item.city_Name,
                provCode: item.prov_Code
              }
            });
           }
          }

        }
      });

      //产能Unit
      this.SelectOptions.UOMOptions = await this.GetMstKeyValueMappingsApi("UOM", "code", "text");

      //产能Time列表
      this.SelectOptions.AbilityunitOptions = await this.GetMstKeyValueMappingsApi("Abilityunit", "code", "text");

      //新品范围列表
      this.SelectOptions.NewsOptions = await this.GetMstKeyValueMappingsApi("Newarea", "code", "text");

      //认证类型列表
      this.SelectOptions.ProductCertifiationTypeOptions = await this.GetMstKeyValueMappingsApi("ProductCertifiationType", "code", "text");

      //發貨時間类型列表
      this.SelectOptions.LeadTimeOptions = (await this.GetMstKeyValueMappingsApi("LeadTime", "code", "text")).filter(item => item.id != '1');

    },
    countryOptionsUpdateOrder(id) {
      const index = this.SelectOptions.countryOptions.findIndex(item => item.id === id);
      this.SelectOptions.countryOptions.unshift(this.SelectOptions.countryOptions.splice(index, 1)[0]);
    },
    //获取MstKeyValueMappings相关数据
    async GetMstKeyValueMappingsApi(MstKeytype, code, text) {
      var data = [];
      await productService
        .GetMstKeyValueMapping({ type: MstKeytype, langId: this.langid })
        .then((res) => {
          if (res.isSuccessful) {
            if(res.data&&res.data.length){
            data = res.data.map(item => ({
              id: item[code],
              label: item[text]
            }))
           }
          }
        });
      return data;
    },
    //子组件保存
    SaveChildPage() { 
      //返回状态的目的是为了确保子组件的内容已经提交通过
      return new Promise((resolve, reject) => {
        this.$refs[this.GetTabRef].Save().then(res => {
          resolve(res);
        }).catch(err => {
          console.log("SaveChildPage err: ", err);
          if (err.newProductId) {
            this.ReloadCurrentPageWithNewProductId(err.newProductId);
          }

          reject(err);
        });
      });
    },
    //重新初始话当前子组件方法
    LoadingChildPage() {
      this.$refs[this.GetTabRef].InitData();
    },
   
    //子组件提交
    SubmitChildPage() {
      let tabIndexName=this.GetTabRef;
      //返回状态的目的是为了确保子组件的内容已经提交通过
      return new Promise((resolve, reject) => {
        this.$refs[tabIndexName].Submit().then(res => {
          resolve(res);
        }).catch(err => {
          console.log("SubmitChildPage err: ", err);
          if (err.newProductId) {
            this.ReloadCurrentPageWithNewProductId(err.newProductId);
          }

          reject(err);
        });
      });
    },
    async btnSave_Click() {
      // this.$swal({
      //   text: this.$t("lbl_EMPBE_AreYouSureToSave"),
      //   showCancelButton: true,
      //   confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
      //   cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      // }).then(async (res) => {
      //   if (res.isConfirmed) {

      this.Save();
      //   }
      // });
    },

    async btnSyncToFrontEnd_Click() {
      this.$swal({
        text: this.$t("lbl_EMPBE_AreYouSureToSyncToFrontEnd"),
        showCancelButton: true,
        confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
        cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      }).then(async (res) => {
        if (res.isConfirmed) {
          productService.SyncProductToFrontEnd({
            delimitedProductId: String(this.ThenProductId)
          }).then(result => {
            if (result.isSuccessful) {
              this.ShowResultMessagePopup(true, this.$t("Lbl_SyncToFrontEnd_Success"), false);
            } else {
              const msg = result.msg && result.msg.length ? result.msg.join('; ') : this.$t("Lbl_SyncToFrontEnd_Failed");
              this.ShowResultMessagePopup(false, msg, false);
            }
          }).catch(err => {
            console.error('SyncProductToFrontEnd error:', err);
            this.ShowResultMessagePopup(false, this.$t("Lbl_SyncToFrontEnd_Failed"), false);
          });
        }
      });
    },

    ReloadCurrentPageWithNewProductId(newProductId) {
      if (newProductId) {
        this.$router.replace('/productInfoCenter/productDetail/' + newProductId).then(() => {
          // 等待路由参数更新后再刷新子组件
          this.$nextTick(() => {
            this.LoadPagetTimer();
            this.loadData();
          });
        }); 
      }
    },

    SetIsSavingOrSubmitting(isSavingOrSubmitting) {
      this.IsSaveOrSubmitBtnClicked = isSavingOrSubmitting;
      if(this.$refs[this.GetTabRef]) {
        this.$refs[this.GetTabRef].loading = isSavingOrSubmitting;
      }
    },

    LogPageFormError(errorLogObj, action) {
      LogService.LogFormErrorWithObj({
        EmpCompanyId: this.companyid,
        EmpProductId: this.ThenProductId,
        PageName: this.$route.path.split("/")[1],
        SectionName: "ProductDetail_Index",
        Action: action,
      }, errorLogObj);
    },

    Save(toPage) {
      // console.log('topage:'+toPage)
      this.SetIsSavingOrSubmitting(true);
      this.SaveChildPage().then(SaveRes => {
        if (SaveRes.state) {
          this.refreshDraftBannerTimestamps();
          let isLastSave = false;

          if (this.ThenProductId==0) {
           //this.ProductId=SaveRes.data
           this.$router.replace('/productInfoCenter/productDetail/' + SaveRes.data);
          }
          if (toPage>=0) {
            // 切 Tab 自动保存：管理员/供应商都不弹 LastSave（此前 fromAdmin 会一直弹「保存成功」框）
            this.BeforeSave(SaveRes.data,toPage);
          } else {
            if (this.fromAdmin||this.TabList.length - 1 == this.TabIndex){
              this.LastSave(SaveRes.data);
              isLastSave = true;
            } else {
              this.BeforeSave(SaveRes.data,toPage);
            }
          }

          if (!isLastSave) {
            // 切换 tab 自动保存：顶部轻提示；手动点保存：沿用原弹窗
            if (toPage >= 0) {
              this.$submitFormMessage.HideMessagePopup();
              // Figma：成功轻提示（3s / 300ms 淡出 / 不叠多个）
              this.$showEmpSuccessToast();
            } else {
            this.ShowResultMessagePopup(true, this.$t("lbl_EMPBE_SubmitAlert_SaveSuccessMessage"), false);
            }
          }
        } else {
          if (toPage >= 0) {
            this.$submitFormMessage.HideMessagePopup();
          }
          this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_Save_Failed"), false);
        }
      }).catch(err => {
        if (toPage >= 0) {
          this.$submitFormMessage.HideMessagePopup();
        }
        this.ShowResultMessagePopup(false, err.message || this.$t("lbl_emp2_PopupFailedBody"), false);
        console.error(err);
      }).finally(() => {
        this.SetIsSavingOrSubmitting(false);
      });
    },
    BeforeSave(data,toPage) {
      //不做新增或者修改的判断 成功直接改路由就可以了
      if(this.ThenProductId==0){
      this.$router.replace('/productInfoCenter/productDetail/' + data);
      }    

      //若是真的当前是insert 的情况下必然还是需要延时来加载 以便子组件能响应
      setTimeout(() => { 
        this.PageNext(toPage); 
        this.LoadPagetTimer();
        this.loadData();//左边必填项目
         //this.refreshParent(); //非弹框无需刷新了
        this.IsSaveOrSubmitBtnClicked = false;
      }, (300));
      //this.LoadingChildPage();
    },
    LastSave(data) {
      // 与公司资料一致：先关掉「正在写入…」进度框，再弹保存成功询问
      this.$submitFormMessage.HideMessagePopup();
      //这里用mixins 的 AlertDialog 方法 用来提示保存后是否执行的ui 内容 
      this.showSaveSucess(this.$t('lbl_EMPBE_Save_Success'), this.$t('lbl_EMPBE_ProductInfo_Submit_Body')).then(SaveSucess => {

        //不做新增或者修改的判断 成功直接改路由就可以了
        if(this.ThenProductId==0){
          this.$router.replace('/productInfoCenter/productDetail/' + data);
        }  
        if (SaveSucess.isConfirmed) {
          this.Submit(); 
          this.selectTab(this.TabIndex);  
        } else {
          //若是真的当前是insert 的情况下必然还是需要延时来加载 以便子组件能响应
          setTimeout(() => { 
            this.LoadPagetTimer();
            this.loadData(); 
          }, (300)); 
        }
        this.IsSaveOrSubmitBtnClicked = false;
      })
    },
    async btnSubmit_Click() {

      // this.$swal({
      //   //Show Alert
      //   text: this.$t("lbl_EMPBE_AreYouSureToSubmit"),
      //   showCancelButton: true,
      //   type: "confirm",
      //   showConfirmButton: true,
      //   confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
      //   cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
      // }).then(async (res) => {
      //   if (res.isConfirmed) {
      this.Submit();
      //   }
      // });
    },
    async Submit(toPage) {
      // 提交前刷新配额占用（独立接口，不走产品列表）
      await this.GetProductQuota();
      await this.GetProductCount();
      // 当前产品已占名额（自己是「第 N 个」里的一员，含第 100 个）→ 允许再提交；否则满额拦截
      if (this.ProductQuota > 0
        && this.ProductCount >= this.ProductQuota
        && !this.ProductCurrentOccupiesQuota) {
        await this.showProductQuotaFullDialog();
        return;
      }
      if (this.GetTabRef =="tab3" && this.$refs[this.GetTabRef].IsShowMainProductErrorTips) {
        this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_ProductInfoIsMainError"), true);
        return;
      }
      this.SetIsSavingOrSubmitting(true);
      //先执行 save 在提交 
      this.SubmitChildPage().then(SaveRes => {
        //不做新增或者修改的判断 成功直接改路由就可以了
        if(SaveRes && SaveRes.data){
          if(!this.fromAdmin&&this.ThenProductId==0){
             this.$router.replace('/productInfoCenter/productDetail/' + SaveRes.data).then(() => {
              // 等待路由参数更新后再刷新子组件
              this.$nextTick(() => {
                if (toPage) {
                  this.PageNext(toPage);
                }
                this.LoadingChildPage();
                this.LoadPagetTimer();
                this.loadData(); 
              });
            }); 
          }
        }

        this.$submitFormMessage.NextStepSubmitMessagePopup({ isCurrentStepFailed: false });

        setTimeout(() => {
          this.loadData().then(loadDataParms => {

            // 仅验证「未填必填」Tab，不把字段驳回提示计入提交失败列表
            var nameList = this.TabList.map((item, i) => {
              return {
                sequenceNums: i,
                hasUnfilledRequired: tabHasSubmitBlockingUnfilled(this, item),
                name: item.name
              }
            }).filter((item) => item.hasUnfilledRequired).map(item => `(${item.sequenceNums + 1}) ${item.name}`)

            if (nameList.length > 0) {
              this.ShowResultMessagePopup(false, this.$t("lbl_EMPBE_SubmitAlert_SubmitFailedMsg"), true, nameList);
              this.$store.state.dirty = false;

              this.LoadPagetTimer();
              //this.refreshParent(); //非弹框无需刷新了
              this.SetIsSavingOrSubmitting(false);
              return;
            }

            productService.SubmitProductInfo({
              ProductId: this.ThenProductId,
              isAdminSubmit: !!this.fromAdmin,
              skipAiApproval: process.env.VUE_APP_EMP_ENV_NAME?.toLowerCase() === 'ai',
            }).then(res => {
              if (res.isSuccessful) {
                if(this.fromAdmin)
                {
                  this.refreshParent_adminGridview();
                }

                this.ShowResultMessagePopup(
                  true,
                  this.$t('lbl_EMPBE_Company_SubmitSuccess_Body'),
                  true,
                  [],
                  this.$t('lbl_EMPBE_Company_SubmitSuccess_Title'),
                );

                this.$nextTick(() => {
                  if (toPage) {
                    this.PageNext(toPage);
                  }
                  this.LoadPagetTimer();
                  this.loadData(); 
                });
              } else {
                this.LogPageFormError({ res }, "Submit_SubmitProductInfo");
                this.ShowResultMessagePopup(false, this.$t('lbl_emp2_PopupFailedTitle'), true);
              }

              this.SetIsSavingOrSubmitting(false);
              this.$store.state.dirty = false;
            }).catch((err) => {
              this.LogPageFormError({ ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack }, "Submit_SubmitProductInfo");
              console.error(err);
            })
          })
        }, (300));

      }).catch((err) => {
        console.error(err);
        this.SetIsSavingOrSubmitting(false);
        this.ShowResultMessagePopup(false, err.message || this.$t('lbl_emp2_PopupFailedTitle'), true);
      });
    },
    // 管理员界面专用 - 刷新父级列表
    refreshParent_adminGridview() {
      // 最多向上查找一定层级，避免任何异常情况下的死循环
      let parent = this.$parent;
      let depth = 0;
      const maxDepth = 20;
      while (parent && !parent.LoadSupplierData && depth < maxDepth) {
        parent = parent.$parent;
        depth++;
      }
      if (parent && typeof parent.LoadSupplierData === 'function') {
        parent.LoadSupplierData();
      } else {
        // 可以按需改成 this.$message / this.$notify 提示
        console && console.warn && console.warn('未找到包含 LoadSupplierData 的父组件');
      }
    },
    
    // async SaveOrSubmitByStatus(){
    //    const status=this.GetPageState;
    //    if(status==1)
    //    {
    //     this.btnSubmit_Click();
    //    }else{
    //       this.IsSaveOrSubmitBtnClicked = true;
    //         this.SaveChildPage().then(SaveRes => {
    //           if (SaveRes.state) { 
    //               this.LastSave(SaveRes.data); 
    //               setTimeout(() => {
    //               var tabtitleObj=document.getElementById('tab_product_'+this.ThenProductId);
    //               if(tabtitleObj)
    //               {  
    //                   let productname=this.GetPageTitleName();
    //                   tabtitleObj.innerText=productname; 
    //               } 
    //               }, 300);
    //           }
    //         });
    //    }
    // },
    /**
     * 管理员：编辑模式 ↔ 审批模式（新开一页，本页不跳转）
     * - 编辑模式：/Management/supplier
     * - 审批模式：/Management/CompanyApproval
     */
    switchAdminEditApprovalMode() {
      if (!this.fromAdmin) return;
      if (!this.isApprovalMode && this.displayApprovalStatus === PRODUCT_DISPLAY_STATUS.toBeSubmitted) {
        return;
      }
      const accountId = this.companyid;
      if (!accountId) return;

      this.confirmSwitchAdminMode(this.isApprovalMode).then((res) => {
        if (!res.isConfirmed) return;

        const query = {
          companyId: String(accountId),
          tab: 'product',
          productId: String(this.ThenProductId || ''),
        };
        if (!query.productId) {
          delete query.productId;
        }

        const path = this.isApprovalMode
          ? '/Management/supplier'
          : '/Management/CompanyApproval';
        const { href } = this.$router.resolve({ path, query });
        window.open(href, '_blank');
      });
    },
    //删除和下架
    DeleteAndDelisted(event) {
      if (!event || event.disabled) {
        return;
      }
      if (event.eventName == "SwitchMode") {
        this.switchAdminEditApprovalMode();
        return;
      }
      if (event.eventName == "Delete") {
        this.showConfirm(
          this.$t('lbl_EMPBE_ProductInfo_Delete_Title'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Body'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Buttom'),
          this.$t('lbl_EMPBE_ProductInfo_Delete_Cancel')
        ).then(async (res) => {
          if (res.isConfirmed) {
            //删除product
            this.Delete().then(res => {
              if (res) {
                if(!this.fromAdmin) {
                setTimeout(() => {
                  this.$router.replace('/productInfoCenter/default');
                  //this.refreshParent(); //非弹框无需刷新了
                }, 500);
              }
               
              }
            })
          }
        });
      }
      else if (event.eventName == "Delist") {
        //下架
        // this.showConfirm("title", "text","confirmButton","cancelButton").then(async (res) => {
        //   if (res.isConfirmed) {
        //删除product
        this.Delist().then(res => {
          if (res) {
            if(this.fromAdmin)
            { 
              this.refreshParent_adminGridview();
            }   
            //退出当前dialog框
            this.LoadPagetTimer();
            // console.log("下架成功");
            // setTimeout(() => {
            //   this.$router.replace('/productInfoCenter/default');
            //   //this.refreshParent();
            // }, 500);
          }
        })
        //   }
        // });
      }
    },
    //下架
    Delist() {
      return new Promise((resolve, reject) => {
        productService.CheckProductBeforeDelete({ productid: this.ThenProductId }).then(res => {
          let message = res.isSuccessful ? this.$t("lbl_EMPBE_DelistSuccess") : this.$t("lbl_EMPBE_DelistFailed");
          let title = res.isSuccessful ? this.$t("lbl_EMPBE_DelistSuccess") : this.$t("lbl_EMPBE_DelistFailed");

          if (!res.isSuccessful) {
            if (res.data == 'LinkedAd') {
              message = this.$t("lbl_EMPBE_ProductDeleteCheck_LinkedAdDelist");
            }

            this.$submitFormMessage.ShowMesaagePopup({ title, message: title === message ? "" : message });
            resolve(false);
          } else {
            productService.DelistProduct({ companyId: this.companyid, ProductId: this.ThenProductId }).then(delistRes => {
              this.$submitFormMessage.ShowMesaagePopup({ title: delistRes.isSuccessful ? this.$t('lbl_EMPBE_DelistSuccess') : this.$t('lbl_EMPBE_DelistFailed') });

              if (!delistRes.isSuccessful) {
                this.LogPageFormError({ res: delistRes }, "Delist_Product");
              }

              resolve(delistRes.isSuccessful ?? false);
            })
          }
        }).catch(err => {
          this.$submitFormMessage.ShowMesaagePopup({ title: this.$t('lbl_EMPBE_DelistFailed') });
          this.LogPageFormError({ Error: { ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack } }, "Delist_Product");
          reject(err);
        });
      });
    },
    //刪除
    Delete() {
      return new Promise((resolve, reject) => {
        //产品 有沒有ad linkage
        productService.CheckProductBeforeDelete({ productid: this.ThenProductId }).then(res => {
          let message = res.isSuccessful ? this.$t("lbl_EMPBE_DeleteSuccess") : this.$t("lbl_EMPBE_DeleteFailed");
          let title = res.isSuccessful ? this.$t("lbl_EMPBE_DeleteSuccess") : this.$t("lbl_EMPBE_DeleteFailed");

          if (!res.isSuccessful) {
            if (res.data == 'LinkedAd') {
              message = this.$t("lbl_EMPBE_ProductDeleteCheck_LinkedAd");
            }

            this.$submitFormMessage.ShowMesaagePopup({ title, message: title === message ? "" : message });
            resolve(false);
          } else {
            productService.ProductDelete({ companyId: this.companyid, ProductId: this.ThenProductId }).then(deleteRes => {
              this.$submitFormMessage.ShowMesaagePopup({ title: deleteRes.isSuccessful ? this.$t('lbl_EMPBE_DeleteSuccess') : this.$t('lbl_EMPBE_DeleteFailed') });

              if (!deleteRes.isSuccessful) {
                this.LogPageFormError({ res: deleteRes }, "Delete_Product");
              }

              resolve(deleteRes.isSuccessful ?? false);
            })
          }
        }).catch(err => {
          this.$submitFormMessage.ShowMesaagePopup({ title: this.$t('lbl_EMPBE_DeleteFailed') });
          this.LogPageFormError({ Error: { ErrorName: err.name, ErrorMessage: err.message, ErrorStack: err.stack } }, "Delete_Product");
          reject(err);
        });
      });
    },
     //跳上一页
    PrePage() {
      // console.log('跳上一页'+this.TabIndex)
      for (var i = this.TabList.length-1; i >= 0; i--) {
        if (i <this.TabIndex && this.TabList[i].IsShow) {
          this.TabIndex = i;
          break;
        }
      }
    },
    //跳下一页
    PageNext(toPage) {
      if(toPage!=undefined&&toPage!=null)
      { 
         this.selectTab(toPage);   
         this.TabIndex=toPage;
      }else{
        for (var i = 0; i < this.TabList.length; i++) {
          if (i > this.TabIndex && this.TabList[i].IsShow) {
            this.TabIndex = i;
            this.selectTab(this.TabIndex);  
            // this.goingToTabIndex=-1;
            break;
          }
        }
      }
      
    }, 
    //预览
    todoViewLive(){
     if(this.canViewLive)
      {
        const baseUrl =process.env.VUE_APP_EMP_VIEW;
        let href_Product=`${baseUrl}ProductInfo/simp?compid=${this.companyid}&SeqId=${this.ThenProductId}`
        window.open(href_Product, '_blank');
      }
    },
    backToDefaultPage(){
      // 管理员模式下，通过事件通知父组件隐藏详情页
      if(this.fromAdmin){ 
        if (this.$store.state.dirty) {
          const status=this.GetPageState;  
            this.showLeavePageAfterSave(
                status==1?this.PageLeaveContent.SubmitTitle:this.PageLeaveContent.SaveTitle,
                status==1?this.PageLeaveContent.SubmitText:this.PageLeaveContent.SaveText,
                status==1?this.PageLeaveContent.SubmitConfirmBtn:this.PageLeaveContent.SaveConfirmBtn
        ).then((result) => {
            if (result.isDenied) { 
              let type=0;
                this.$emit('hide-detail',type);
            } else if (result.isConfirmed) {
              //提交操作
              if (this.GetPageState == 1)
              {
                this.Submit(); 
              } else {
                this.SetIsSavingOrSubmitting(true);
                this.SaveChildPage().then(SaveRes => {
                  if (SaveRes.state) {
                    setTimeout(() => {
                      let type=0;
                      this.$emit('hide-detail',type); 
                    }, 600); 
                  }
                }).catch(err => {
                  this.ShowResultMessagePopup(false, err.message || this.$t("lbl_emp2_PopupFailedBody"), false);
                  console.error(err);
                }).finally(() => {
                  this.SetIsSavingOrSubmitting(false);
                });
              }
            }
          }); 

        }else{
         let type=0;
         this.$emit('hide-detail',type);
        }
       
      } else {
        // 普通模式下，导航回默认路由，显示 productListing 组件
        this.$router.replace('/productInfoCenter/default');
      }
      
    },
    //  LeavePageMethodsBypProductDetail(productId) {
    //   productService
    //     .GetProductInfoStatus({ companyId: this.companyid, ProductId: productId })
    //     .then((res) => {
    //       if (res.isSuccessful) {
    //         //上架
    //         if(res.data?.lastSubmitDate != '' &&  res.data?.isLaunch == 1)
    //         {
      //     this.LeavePageMethodsAfterSave(
      //           this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Title'),
      //           this.$t('lbl_EMPBE_ProductInfo_PageLeaveSubmit_Body'),
      //           this.$t('lbl_EMPBE_CompanyInfo_Submit'),
    //             'product'
    //           );
    //         }else 
    //         {
    //           this.LeavePageMethodsAfterSave(
    //             this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
    //             this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
    //             this.$t('lbl_EMPBE_CompanyInfo_Save'),
    //             'product'
    //           );
    //         }
    //       }else
    //       {
    //         this.LeavePageMethodsAfterSave(
    //             this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Title'),
    //             this.$t('lbl_EMPBE_ProductInfo_PageLeaveSave_Body'),
    //             this.$t('lbl_EMPBE_CompanyInfo_Save'),
    //             'product'
      //         );
      //   }
    //     }).catch(() => {
    //     })
    // },
    async LeavePageMethodsAfterSave(title,text,btnName,type) {
      await this.showLeavePageAfterSave(
                title,
                text,
                btnName
      ).then((result) => {
        if (result.isDenied) { 
          this.$router.replace("/productInfoCenter/default");
        } else if (result.isConfirmed) {
          //提交操作
          if (this.GetPageState == 1) {
            this.Submit();
            //this.ToIndexPage();
          } else {
            this.SetIsSavingOrSubmitting(true);
            this.SaveChildPage().then(SaveRes => {
              if (SaveRes.state) {
                this.$router.replace("/productInfoCenter/default");
              }
            }).catch(err => {
              this.ShowResultMessagePopup(false, err.message || this.$t("lbl_emp2_PopupFailedBody"), false);
              console.error(err);
            }).finally(() => {
              this.SetIsSavingOrSubmitting(false);
            });
          }
        }
      }); 
    },
    //ToIndexPage(){
      // console.log("当前状态", this.IsSaveOrSubmitBtnClicked)
      // if(this.IsSaveOrSubmitBtnClicked==false){
      //   this.$router.replace("/productInfoCenter/default");
      //  }else{
      //    setTimeout(() => {
      //    // this.tabIndex=this.goingToTabIndex;
      //       this.ToIndexPage();
      //     }, 300);
      //  }
    //},
    selectTab(tabIdx){ //error 框
      var tabName=this.TabList[tabIdx].ProgressPage;  
      this.selectedTabName=tabName;   
    },
    /** PublicTabs 切 tab 触发的 save：审批走驳回落库，编辑走产品草稿 */
    onTabSave(toPage) {
      if (this.isApprovalMode) {
        // 已通过 / 未提交：无驳回框，切 Tab 不落库
        if (!this.showProductRejectPanels) {
          this.PageNext(toPage);
          return;
        }
        this.saveApprovalRejectThenGo(toPage);
        return;
      }
      this.Save(toPage);
    },
    async saveApprovalRejectThenGo(toPage) {
      // 与供应商 dirty 一致：有驳回改动才落库并提示，否则直接切 Tab
      if (this.hasApprovalRejectChanges('current')) {
        await this.saveApprovalRejectContent({ silent: false, scope: 'current' });
      }
      this.PageNext(toPage);
    },
    preOrNextTab(tabname) {
      const tabIndex = this.TabList.findIndex(item => item.ProgressPage === tabname);
      if (tabIndex !== -1) { 
        this.nextTabSaveOrSubmit(tabIndex);
      } 
    }, 
     selectName(tabName){ 
      //  console.log('selectName'+tabName)  
       var tabIndex=this.TabList.findIndex(a=>a.ProgressPage==tabName);       
        if (tabIndex !== -1) { 
           this.nextTabSaveOrSubmit(tabIndex);
       }
    },
   nextTabSaveOrSubmit(tabidx){
    // 审批模式：切分区先保存当前页驳回（总驳回 + 本页子项）
    if (this.isApprovalMode) {
      if (!this.showProductRejectPanels) {
        this.TabIndex = tabidx;
            this.selectTab(this.TabIndex);
        return;
      }
      this.saveApprovalRejectThenGo(tabidx);
      return;
    }
    // 有未保存改动：切换分区时自动保存草稿（不再弹确认框）
    if (this.$store.state.dirty) {
      this.Save(tabidx);
    } else {
      this.TabIndex=tabidx;
      this.selectTab(this.TabIndex); 
    } 
  },
  //  async saveisMainProduct() {
  //   console.log('saveisMainProduct')
  //   var that = this; 
  //   this.$swal({
  //       //Show Alert
  //       text: this.$t("lbl_EMPBE_confirmtoSaveToMainProd"),
  //       showCancelButton: true,
  //       type: "confirm",
  //       showConfirmButton: true,
  //       confirmButtonText: this.$t("lbl_EMPBE_Confirm"),
  //       cancelButtonText: this.$t("lbl_EMPBE_Cancel"),
  //     }).then(async (res) => {
  //       if (res.isConfirmed) {  
  //         var parms = { productid: this.ThenProductId, isMainProduct: this.IsMainProduct?1:0 };
  //           productService.UpdateProductMainProd(parms).then((res) => {
  //           if (res.isSuccessful) {
  //             var message = that.$t('lbl_EMPBE_SubmitAlert_SaveSuccessTitle');
  //             if(this.GetPageState==1){
  //                this.showSubmitSucess(this.$t('lbl_EMPBE_ProductInfo_SubmitSucess_Title'), this.$t('lbl_EMPBE_ProductInfo_SubmitSucess_Body'));  
  //             }else{
  //                this.showSaveSucess(this.$t('lbl_EMPBE_Save_Success'), this.$t('lbl_EMPBE_ProductInfo_Submit_Body'));
  //             }  
  //          // this.$emit('refreshGrid'); 
  //           } else {
  //           var message = that.$t('lbl_EMPBE_Oprate_Filed');
  //           that.alertMsg(message)
  //           } 
  //           }); 
  //       }else{
  //         this.IsMainProduct=!this.IsMainProduct;
  //       }
  //     }); 
  //    },
  },
  beforeRouteLeave (to, from, next) {
  const status=this.GetPageState; 
    if (this.$store.state.dirty) {
          this.showLeavePageAfterSave(
              status==1?this.PageLeaveContent.SubmitTitle:this.PageLeaveContent.SaveTitle,
              status==1?this.PageLeaveContent.SubmitText:this.PageLeaveContent.SaveText,
              status==1?this.PageLeaveContent.SubmitConfirmBtn:this.PageLeaveContent.SaveConfirmBtn
      ).then((result) => {
        if (result.isDenied) { 
            next() // 允许离开
        } else if (result.isConfirmed) {
          //提交操作
          if (this.GetPageState == 1)
            {  
              this.Submit(); 
                 
            } else { 
              this.SaveChildPage().then(SaveRes => {
                if (SaveRes.state) {
                  next() // 允许离开
                }
              }).catch(err => {
                this.ShowResultMessagePopup(false, err.message || this.$t("lbl_emp2_PopupFailedBody"), false);
                console.error(err);
              });

            }
        }
      }); 
     }else{
       next() // 允许离开
     }
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.refreshStickyLayoutOffsets);
    if (this.pageBodyResizeObserver) {
      this.pageBodyResizeObserver.disconnect();
      this.pageBodyResizeObserver = null;
    }
  },
};
</script>
<style lang="scss" >
  @import "./style/default"; 
</style>
<style >
  #manage_IsMainProduct h6{
  padding-right: 10px;
  margin-bottom: unset;
}
.ActivateColor {
  padding: 8px;
  background: var(--Success-Light, #51BB25);
  color: #fff;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -.154px;
}

.DraftColor {
  padding: 8px;
  background: var(--Warning, #FFD02C); 
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -.154px;
    color: rgb(0, 0, 0);
}

.DelistedColor {
  padding: 8px;
  background: #7A7A7A;
  color: #fff;
    text-align: center;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
    letter-spacing: -.154px;
}

.product-draft-banner {
  margin: 0;
  padding: 12px 32px;
  border-radius: 0;
  background: #ffd02c;
  color: #5c4300;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 2;
  margin-left: 0; 
  min-height: 44px;
  overflow: visible;
  white-space: normal;
  opacity: 1;
  visibility: visible;
}

.product-draft-banner__icon {
  flex-shrink: 0;
  width: 19px;
  height: 24px;
  display: block;
  margin-top: 0;
}

.product-draft-banner__content {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
  overflow: visible;
}

.product-draft-banner__title {
  display: block;
  font-size: 16px !important;
  font-weight: 700;
  line-height: 18px;
  color: #5c4300 !important;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-break: break-word;
}

.product-draft-banner__desc {
  display: block;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #5c4300 !important;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-break: break-word;
}

.product-draft-banner,
.product-draft-banner * {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: clip !important;
}

/* Figma: RejectAction V3 — Supplier Overall (node 902:35002) */
.product-reject-banner {
  margin: 0;
  padding: 16px;
  border-radius: 16px;
  border: 1px solid #dc3545;
  background: rgba(255, 230, 230, 0.4);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
}

.TabHeader .product-reject-banner,
.TabHeader_admin .product-reject-banner {
  width: 100%;
  margin: 0;
}

.product-reject-banner__title {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  color: #dc3545;
  word-break: break-word;
}

.product-reject-banner__desc-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.product-reject-banner__desc {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  color: rgba(0, 0, 0, 0.8);
  white-space: pre-wrap;
  word-break: break-word;
  width: 100%;
}

.product-reject-banner__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 21px;
  padding: 0;
  border: 0;
  background: transparent;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
}

.product-reject-banner__link-icon {
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.8);
}

.product-reject-banner__link:hover {
  text-decoration: underline;
}

.product-submit-fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

/*
 * 审批只读：禁止改表单，但驳回框要能聚焦输入。
 * 勿在容器上用 pointer-events:none —— Chromium 下祖先 none 时，
 * 子级即便 auto，textarea 也经常点得着却无法输入。
 */
.product-submit-fieldset.is-approval-readonly {
  opacity: 1;
}

.product-submit-fieldset.is-approval-readonly input,
.product-submit-fieldset.is-approval-readonly textarea,
.product-submit-fieldset.is-approval-readonly select,
.product-submit-fieldset.is-approval-readonly button,
.product-submit-fieldset.is-approval-readonly a,
.product-submit-fieldset.is-approval-readonly label,
.product-submit-fieldset.is-approval-readonly [contenteditable],
.product-submit-fieldset.is-approval-readonly .vue-treeselect,
.product-submit-fieldset.is-approval-readonly .mx-datepicker,
.product-submit-fieldset.is-approval-readonly .custom-file,
.product-submit-fieldset.is-approval-readonly .gallery-item,
.product-submit-fieldset.is-approval-readonly .gallery-item-add {
  pointer-events: none !important;
}

.product-submit-fieldset.is-approval-readonly .product-field-approval-results,
.product-submit-fieldset.is-approval-readonly .product-field-approval-results *,
.product-submit-fieldset.is-approval-readonly .product-approval-result-field,
.product-submit-fieldset.is-approval-readonly .product-approval-result-field *,
.product-submit-fieldset.is-approval-readonly .frf,
.product-submit-fieldset.is-approval-readonly .frf *,
.product-submit-fieldset.is-approval-readonly .frf input,
.product-submit-fieldset.is-approval-readonly .frf textarea,
.product-submit-fieldset.is-approval-readonly .frf button,
.product-submit-fieldset.is-approval-readonly .frf__input,
.product-submit-fieldset.is-approval-readonly .mrb,
.product-submit-fieldset.is-approval-readonly .mrb *,
.product-submit-fieldset.is-approval-readonly .mag,
.product-submit-fieldset.is-approval-readonly .mag *,
.product-submit-fieldset.is-approval-readonly .mag button,
.product-submit-fieldset.is-approval-readonly .mpp-overlay,
.product-submit-fieldset.is-approval-readonly .mpp-overlay * {
  pointer-events: auto !important;
}

/* placeholder 盖在输入框上，必须继续穿透，否则空原因时点不进去 */
.product-submit-fieldset.is-approval-readonly .frf__placeholder {
  pointer-events: none !important;
}

/* Header changed to two lines, so lift both fixed columns together */
.form .productInfo {
  padding-top: var(--np-content-top, 64px) !important;
}

.form.Newproductbox--has-reject-banner .productInfo {
  padding-top: 16px !important;
}

.form,
.formAdmin {
  --np-form-gutter-x: 16px;
}

.form .PublicTabs,
.formAdmin .PublicTabs {
  padding-left: var(--np-form-gutter-x, 16px);
  padding-right: var(--np-form-gutter-x, 16px);
}

.form > .product-reject-banner,
.formAdmin > .product-reject-banner,
.formAdmin > .product-overall-reject {
  margin-left: var(--np-form-gutter-x, 16px);
  margin-right: var(--np-form-gutter-x, 16px);
  width: calc(100% - 2 * var(--np-form-gutter-x, 16px));
  box-sizing: border-box;
}

.formAdmin > .product-reject-banner {
  margin-bottom: 16px;
}

.form .leftCard_proInfo {
  top: var(--np-left-top, 128px) !important;
}

.form .tab-left-Big {
  top: var(--np-left-top, 128px) !important;
}

.form .product-draft-banner--above-body {
  width: calc(100vw - var(--np-main-offset-left, 0px));
  max-width: calc(100vw - var(--np-main-offset-left, 0px));
  margin-left: calc(
    var(--np-main-offset-left, 0px)
    - var(--np-header-offset-left, 0px)
    - var(--np-form-gutter-x, 16px)
  );
  margin-right: 0;
  box-sizing: border-box; 
}

.formAdmin .product-draft-banner--above-body {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: 0;
  box-sizing: border-box; 
}
</style>
<style scoped>
.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
}

.container-fluid {
  position: relative;
}

/* #productRightpopup {
  background: var(--Background, #F2F3F5);

} */
.tbbody {
  display:flex;
  justify-content: center;
  position: relative;
}
.form {
  width: 100%;
  max-width: 1167px;
  box-sizing: border-box;
}

.TabHeader{
width: var(--np-form-width, 1167px);
max-width: 1167px;
left: var(--np-form-left, 0);
flex-direction: column;
justify-content: center;
align-items: stretch;
display: flex;
position: fixed;
top: 30px;
z-index: 3;
background: #F8F8F8;
padding-left: var(--np-form-gutter-x, 16px);
padding-right: var(--np-form-gutter-x, 16px);
box-sizing: border-box;
}
.TabHeader_body{
  width: 100%; 
  border-radius: 16px;  
  align-items: flex-start; 
  display: flex;
  gap: 16px;
   min-height: 34px;
   height: auto;
    margin: 12px 0;
    position: relative;
}
.topMenuRight{
    gap: 8px;
    min-height: 34px;
    justify-content: flex-end;
    align-items: flex-start;
    display: flex;
    flex-shrink: 0;
    position: relative;
    right: auto;
}

.headerTitleBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  /* Figma: 标题区 flex-1，右侧按钮 shrink-0，长标题用省略号 */
  flex: 1 1 auto;
  min-width: 0;
  max-width: none;
}

.headerBreadcrumbLine {
  display: flex;
  gap: 4px;
  align-items: center;
  line-height: 23.4px;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.statusLine {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.statusLabel {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.statusPill {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.statusPill.is-approved {
  background: #51bb25;
  color: #fff;
}

.statusPill.is-rejected {
  background: #de3a4a;
  color: #fff;
}

.statusPill.is-syncing {
  background: #3a7bd5;
  color: #fff;
}

.statusPill.is-manual,
.statusPill.is-not-submitted {
  background: #ffd02c;
  color: rgba(0, 0, 0, 0.8);
}
.product-launch-badge__dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #9e9e9e;
    flex-shrink: 0;
    margin-right: 4px;
}

.statusPill.is-launch-online {
      background: rgba(0, 255, 0, 0.25);
    color: #51BB25;
}
.is-launch-online .product-launch-badge__dot {
    background: #51bb25;
}
.statusPill.is-launch-offline {
      color: rgba(0, 0, 0, 0.60);
    background: rgba(0, 0, 0, 0.05);
}

.statusPill.is-delisted,
.statusPill.is-invalid {
  background: #7f7f7f;
  color: #fff;
}

.statusPill.is-effective-soon,
.statusPill.is-under-review {
  background: #2f73cc;
  color: #fff;
}

.topActionGroup {
  display: inline-flex;
  align-items: stretch;
  gap: 8px;
}

.topActionGroup > * {
  height: auto;
}

.headerActionBtn-wrap {
  display: inline-flex;
}

.headerActionBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  border: 0;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.03);
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.154px;
  height: 36px;
  padding: 0 8px;
  min-width: 0;
  box-sizing: border-box;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.headerActionBtn:not(:disabled):hover {
  background: rgba(0, 0, 0, 0.08);
}

.headerActionBtn:not(:disabled):active {
  background: rgba(0, 0, 0, 0.12);
}

.headerActionBtn__label {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 4px;
  line-height: 20px;
  white-space: nowrap;
}

.headerActionBtn__icon {
  width: 15px;
  height: 15px;
  margin: 0;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
}

.headerActionBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.headerMoreAction {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  padding: 0 4px;
  border-radius: 0;
  background: transparent;
  color: rgba(0, 0, 0, 0.8);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: -0.154px;
  min-width: 0;
  box-sizing: border-box;
  white-space: nowrap;
}

 
.lblproductList{
  color: rgba(0, 0, 0, 0.40);
   font-size: 18px; 
  /* font-family: Inter;  */
  font-weight: 400; 
  line-height: 23.40px; 
  word-wrap: break-word;
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}
.PublicTabs .b_Card{
      margin-bottom: 16px ;
}  
.backAndNext{
  width: 100%; height: 100%; justify-content: space-between; align-items: flex-start; display: inline-flex
}
.backBtn{
  height: 40px;  
  padding: 8px 16px;  
  background: rgba(0, 0, 0, 0.05); 
  border-radius: 99px; 
  justify-content: center; 
  align-items: center; 
  gap: 4px; 
  display: flex;
  color: rgba(0, 0, 0, 0.60);
font-size: 16px;
/* font-family: Inter; */
font-weight: 600;
line-height: 16px;
word-wrap: break-word;
cursor: pointer;

}
.rightBtn{
height: 40px; 
padding: 8px 16px; 
border-radius: 99px;
justify-content: center;
align-items: center;
gap: 4px; 
display: flex;
color: #7366FF;
font-size: 16px;
/* font-family: Inter; */
font-weight: 600;
line-height: 16px;
word-wrap: break-word;
background: white;
cursor: pointer;

}
.iconRight{
  font-size: 20px;
    color: rgba(0, 0, 0, 0.4);
    width: 20px;
    height: 23.4px;
    align-items: center;
    justify-content: center;
    display: inline-flex;
    line-height: 1;
    flex-shrink: 0;
}
.productTitle{
      color: rgba(0, 0, 0, 0.8);
    font-size: 18px;
    /* font-family: Inter; */
    font-weight: 700;
    line-height: 23.4px; 
    min-width: 0;
    flex: 1 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.productTitleRow {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  flex: 1 1 auto;
}
.productTitleRow .productTitle {
  flex: 1 1 auto;
}
.productIdBadge {
  flex-shrink: 0;
  color: rgba(0, 0, 0, 0.55);
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
}
 
 .productstatus{
  color: rgba(0, 0, 0, 0.80); font-size: 16px; font-weight: 700; line-height: 20.80px; word-wrap: break-word

 }
 
</style>
<!--管理员界面专用样式-->
 
<style v-show="fromAdmin" >
 .formAdmin .PublicTabs{
    padding-top: 0;
  }
  /* 管理员详情：左右内容区纯白铺满 */
  #Newproductbox:has(.formAdmin) {
    background: #fff;
    min-height: calc(100vh - 64px);
  }
  .formAdmin{
    width: 100%;
    background: #fff;
    min-height: calc(100vh - 64px);
  }
  /* 白底铺满后加深卡片描边 */
  .formAdmin .bCardStyle,
  .formAdmin .assitantCard,
  .formAdmin .CenterCard {
    border-color: rgba(0, 0, 0, 0.12) !important;
  }
  /* 管理员编辑/审批共用：左侧选项卡宽度与审批模式一致（约 25%） */
  .formAdmin .tab-left-tab {
    flex: 0 0 calc((100% - 24px) * 0.25) !important;
    max-width: calc((100% - 24px) * 0.25) !important;
    width: auto !important;
    padding-right: 0 !important;
  }
  .formAdmin .tab-center-tab {
    flex: 1 1 0 !important;
    max-width: none !important;
    width: auto !important;
    padding-right: 0 !important;
  }
 #Newproductbox .TabHeader_admin{
  width: 100%; 
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  display: -ms-flexbox; 
  background: #fff;
  /* 白底不画进底边 1px，留给下方卡片顶边透出（避免吸顶后顶边被盖住） */
  background-clip: padding-box;
  border-bottom: 1px solid transparent;
  margin: 16px 0 0;
  padding: 0 var(--np-form-gutter-x, 16px) 12px;
  position: sticky !important;
  top: 0;
  z-index: 10;
  pointer-events: auto;
  overflow: visible;
  box-sizing: border-box;
}
.TabHeader_admin .TabHeader_body {
  position: relative;
  z-index: 2;
  overflow: visible;
  width: 100%;
}
.TabHeader_admin .topMenuRight {
  right: 8px;
  z-index: 51;
  overflow: visible;
}
.TabHeader_admin .topMenuRight .PubCustom-select-Container {
  z-index: 52;
}
.TabHeader_admin .topMenuRight .PubCustom-select-Dropdown {
  z-index: 53;
}
/* 总驳回不吸顶：略高于 PublicTabs，但须低于吸顶 TabHeader_admin(10) */
.formAdmin > .product-overall-reject {
  margin: 0 var(--np-form-gutter-x, 16px) 12px;
  width: calc(100% - 2 * var(--np-form-gutter-x, 16px));
  position: relative;
  z-index: 2;
  overflow: visible;
  pointer-events: auto !important;
  box-sizing: border-box;
}
.formAdmin > .product-overall-reject:has(.dropdown.show) {
  z-index: 4;
}
.formAdmin > .product-overall-reject .product-overall-reject__status,
.formAdmin > .product-overall-reject .product-overall-reject__input,
.formAdmin > .product-overall-reject .product-overall-reject__template-dd {
  pointer-events: auto !important;
}
.formAdmin .gallery-item-add,.formAdmin .gallery-item{
  width: 115px !important;
}
 .formAdmin .headerTitleBlock {
  max-width: none;
}
 .formAdmin .productTitle{ 
    max-width: 100%;
}
 #Newproductbox .formAdmin .TabHeader_body{  
   /* margin: 8px 0 !important;  */
}
#AbilityUnit .cps-treeselect .vue-treeselect__control{
  padding: 0px 12px !important;
}
#AbilityPeriod .cps-treeselect .vue-treeselect__control{
  padding: 0px 12px !important;
}
</style>
